// source: pbtypes/tools/cloud_api/feature_flags.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var pbtypes_tools_cloud_api_enums_pb = require('../../../pbtypes/tools/cloud_api/enums_pb.js');
goog.object.extend(proto, pbtypes_tools_cloud_api_enums_pb);
goog.exportSymbol('proto.cloud_api.FeatureFlagRequest', null, global);
goog.exportSymbol('proto.cloud_api.FeatureFlags', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud_api.FeatureFlags = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud_api.FeatureFlags, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud_api.FeatureFlags.displayName = 'proto.cloud_api.FeatureFlags';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud_api.FeatureFlagRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud_api.FeatureFlagRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud_api.FeatureFlagRequest.displayName = 'proto.cloud_api.FeatureFlagRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud_api.FeatureFlags.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud_api.FeatureFlags.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud_api.FeatureFlags} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.FeatureFlags.toObject = function(includeInstance, msg) {
  var f, obj = {
vehicleTeleoperation: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
automaticFileUploadPage: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
vehicleLicensesPage: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
liveStreaming: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
axonMediaIntegration: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
missionsPage: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
vehicleRemoteStreaming: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
mobileRemoteStreaming: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
multiViewerStreaming: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
axonRespondIntegration: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
viewOfflineSettings: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
configureObstacleMargin: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
droInternal: jspb.Message.getBooleanFieldWithDefault(msg, 16, false),
annotations: jspb.Message.getBooleanFieldWithDefault(msg, 21, false),
cloudInspectPage: jspb.Message.getBooleanFieldWithDefault(msg, 22, false),
missionMediaViewer: jspb.Message.getBooleanFieldWithDefault(msg, 23, false),
automaticCloudPhotogrammetry: jspb.Message.getBooleanFieldWithDefault(msg, 26, false),
dockLocationUpdate: jspb.Message.getBooleanFieldWithDefault(msg, 27, false),
disableTeleopLandingPrompt: jspb.Message.getBooleanFieldWithDefault(msg, 29, false),
droTeleopRunMissionJson: jspb.Message.getBooleanFieldWithDefault(msg, 31, false),
hideLandNowDuringRtd: jspb.Message.getBooleanFieldWithDefault(msg, 33, false),
remoteVideoApiAccess: jspb.Message.getBooleanFieldWithDefault(msg, 36, false),
allowTwilightFlight: jspb.Message.getBooleanFieldWithDefault(msg, 38, false),
allowBacktrackingRtx: jspb.Message.getBooleanFieldWithDefault(msg, 39, false),
cloudOta: jspb.Message.getBooleanFieldWithDefault(msg, 40, false),
teleopDebugMenu: jspb.Message.getBooleanFieldWithDefault(msg, 41, false),
qosSkybusChannelSetting: jspb.Message.getBooleanFieldWithDefault(msg, 42, false),
postRefactorMissionEditor: jspb.Message.getBooleanFieldWithDefault(msg, 43, false),
networkDebuggingTools: jspb.Message.getBooleanFieldWithDefault(msg, 46, false),
fullHeightVideoEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 47, false),
navHeightAboveGroundEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 49, false),
internalThemeToggle: jspb.Message.getBooleanFieldWithDefault(msg, 51, false),
customerCustomMapboxMapStyles: jspb.Message.getBooleanFieldWithDefault(msg, 53, false),
showVehicleFaultsTeleop: jspb.Message.getBooleanFieldWithDefault(msg, 63, false),
showVpsInfo: jspb.Message.getBooleanFieldWithDefault(msg, 66, false),
teleopArV2: jspb.Message.getBooleanFieldWithDefault(msg, 67, false),
missionControlApi: jspb.Message.getBooleanFieldWithDefault(msg, 68, false),
scheduleMissionNowApi: jspb.Message.getBooleanFieldWithDefault(msg, 69, false),
surfaceScanMissions: jspb.Message.getBooleanFieldWithDefault(msg, 71, false),
showAprilTagSettings: jspb.Message.getBooleanFieldWithDefault(msg, 72, false),
showSkydioLinkSettings: jspb.Message.getBooleanFieldWithDefault(msg, 73, false),
whatsNew: jspb.Message.getBooleanFieldWithDefault(msg, 76, false),
showRangeLimitSettings: jspb.Message.getBooleanFieldWithDefault(msg, 80, false),
siteMapper: jspb.Message.getBooleanFieldWithDefault(msg, 85, false),
showBandSelectionSettings: jspb.Message.getBooleanFieldWithDefault(msg, 86, false),
flyNowNoAutomaticRunModeSwitching: jspb.Message.getBooleanFieldWithDefault(msg, 87, false),
arVideoSync: jspb.Message.getBooleanFieldWithDefault(msg, 88, false),
missionResults3dViewer: jspb.Message.getBooleanFieldWithDefault(msg, 89, false),
automaticNcpgPhotogrammetry: jspb.Message.getBooleanFieldWithDefault(msg, 92, false),
executiveActionHotkeys: jspb.Message.getBooleanFieldWithDefault(msg, 93, false),
vehicleTypeBasedAxonSessions: jspb.Message.getBooleanFieldWithDefault(msg, 94, false),
siteMissions: jspb.Message.getBooleanFieldWithDefault(msg, 98, false),
alwaysShowCameraSettings: jspb.Message.getBooleanFieldWithDefault(msg, 99, false),
teleopWaypointCommands: jspb.Message.getBooleanFieldWithDefault(msg, 101, false),
droRemoteId: jspb.Message.getBooleanFieldWithDefault(msg, 105, false),
propGuardsEnablement: jspb.Message.getBooleanFieldWithDefault(msg, 108, false),
remotePilotApiAccess: jspb.Message.getBooleanFieldWithDefault(msg, 111, false),
showViewFlightDeckButton: jspb.Message.getBooleanFieldWithDefault(msg, 112, false),
twilightModeFastFlight: jspb.Message.getBooleanFieldWithDefault(msg, 113, false),
standaloneMapPage: jspb.Message.getBooleanFieldWithDefault(msg, 114, false),
missionResume: jspb.Message.getBooleanFieldWithDefault(msg, 115, false),
lostCommsTimeoutSettingTeleop: jspb.Message.getBooleanFieldWithDefault(msg, 116, false),
teleopFastFlight: jspb.Message.getBooleanFieldWithDefault(msg, 117, false),
allowEditAdsbSettings: jspb.Message.getBooleanFieldWithDefault(msg, 119, false),
showTeleopIdleModal: jspb.Message.getBooleanFieldWithDefault(msg, 121, false),
skydioExtend: jspb.Message.getBooleanFieldWithDefault(msg, 122, false),
supportMenuV2: jspb.Message.getBooleanFieldWithDefault(msg, 123, false),
geofenceEnforcementInCloud: jspb.Message.getBooleanFieldWithDefault(msg, 125, false),
sensorDataViewClaim: jspb.Message.getBooleanFieldWithDefault(msg, 126, false),
teleopThirdPersonView: jspb.Message.getBooleanFieldWithDefault(msg, 129, false),
showTeleopCircularBatteryWidget: jspb.Message.getBooleanFieldWithDefault(msg, 132, false),
alertManagerWithAudioInTeleop: jspb.Message.getBooleanFieldWithDefault(msg, 133, false),
structureAnnotationsApi: jspb.Message.getBooleanFieldWithDefault(msg, 134, false),
moveLivestreamTagPosition: jspb.Message.getBooleanFieldWithDefault(msg, 135, false),
showActivePilotNameIfLivestreaming: jspb.Message.getBooleanFieldWithDefault(msg, 136, false),
moveShareLivestreamButtonToIcon: jspb.Message.getBooleanFieldWithDefault(msg, 137, false),
ownOrgGroups: jspb.Message.getBooleanFieldWithDefault(msg, 138, false),
teleopCommandeeringV2: jspb.Message.getBooleanFieldWithDefault(msg, 139, false),
mediaAvailableAlert: jspb.Message.getBooleanFieldWithDefault(msg, 140, false),
mediaAvailableForScanAlert: jspb.Message.getBooleanFieldWithDefault(msg, 141, false),
ncpgPhotogrammetryUseTensorRtFlowModel: jspb.Message.getBooleanFieldWithDefault(msg, 142, false),
showFaaMapboxStyles: jspb.Message.getBooleanFieldWithDefault(msg, 143, false),
allowSchedulingR47Missions: jspb.Message.getBooleanFieldWithDefault(msg, 144, false),
sitesStructureEditor: jspb.Message.getBooleanFieldWithDefault(msg, 147, false),
multiMissionFlightTester: jspb.Message.getBooleanFieldWithDefault(msg, 148, false),
teleopSettingsModalV3: jspb.Message.getBooleanFieldWithDefault(msg, 153, false),
x10EoCameraControlsParityInTeleop: jspb.Message.getBooleanFieldWithDefault(msg, 154, false),
noObstacleAvoidanceInTeleop: jspb.Message.getBooleanFieldWithDefault(msg, 155, false),
liveMissionPlanning: jspb.Message.getBooleanFieldWithDefault(msg, 158, false),
waypointCameraSettings: jspb.Message.getBooleanFieldWithDefault(msg, 161, false),
vpsMapDatamodelTransitionReadFromNew: jspb.Message.getBooleanFieldWithDefault(msg, 162, false),
vpsMapDatamodelTransitionWriteToBoth: jspb.Message.getBooleanFieldWithDefault(msg, 163, false),
editOrgFlightPolicy: jspb.Message.getBooleanFieldWithDefault(msg, 164, false),
teleopWheelZoom: jspb.Message.getBooleanFieldWithDefault(msg, 165, false),
multizoneSiteGeofences: jspb.Message.getBooleanFieldWithDefault(msg, 166, false),
teleopBitrateSlider: jspb.Message.getBooleanFieldWithDefault(msg, 168, false),
x10ZoomAndFlashUi: jspb.Message.getBooleanFieldWithDefault(msg, 169, false),
ridFeatureDisabled: jspb.Message.getBooleanFieldWithDefault(msg, 171, false),
removeFlightFromResourceGroup: jspb.Message.getBooleanFieldWithDefault(msg, 173, false),
safeLandingPoints: jspb.Message.getBooleanFieldWithDefault(msg, 174, false),
teleopBoostMode: jspb.Message.getBooleanFieldWithDefault(msg, 177, false),
teleopCrawlMode: jspb.Message.getBooleanFieldWithDefault(msg, 178, false),
enableFlyToPoiRfd: jspb.Message.getBooleanFieldWithDefault(msg, 179, false),
showOperationsAreaMapboxStyles: jspb.Message.getBooleanFieldWithDefault(msg, 180, false),
barometerHeightMode: jspb.Message.getBooleanFieldWithDefault(msg, 183, false),
graphiqlViewer: jspb.Message.getBooleanFieldWithDefault(msg, 186, false),
enableOrbitToPoiRfd: jspb.Message.getBooleanFieldWithDefault(msg, 187, false),
disableCloudConfigSignatureVerification: jspb.Message.getBooleanFieldWithDefault(msg, 188, false),
isOnpremOrg: jspb.Message.getBooleanFieldWithDefault(msg, 189, false),
enablePointerLockDuringMissionsRfd: jspb.Message.getBooleanFieldWithDefault(msg, 190, false),
enableMapVehicleFollowiing: jspb.Message.getBooleanFieldWithDefault(msg, 192, false),
readyLinkSingleVehicle: jspb.Message.getBooleanFieldWithDefault(msg, 193, false),
teleopTelemetryHeadingAndGimbalPitch: jspb.Message.getBooleanFieldWithDefault(msg, 194, false),
mediaPageKindDropdown: jspb.Message.getBooleanFieldWithDefault(msg, 195, false),
teleopActionsToolbar: jspb.Message.getBooleanFieldWithDefault(msg, 196, false),
enableDockLandingAr: jspb.Message.getBooleanFieldWithDefault(msg, 199, false),
teleopNavSourceInfoHealth: jspb.Message.getBooleanFieldWithDefault(msg, 201, false),
enableAxonMarkersRfd: jspb.Message.getBooleanFieldWithDefault(msg, 202, false),
enableFpvOnMap: jspb.Message.getBooleanFieldWithDefault(msg, 203, false),
offlineUpdatesPage: jspb.Message.getBooleanFieldWithDefault(msg, 204, false),
gimbalPitchResetShortcut: jspb.Message.getBooleanFieldWithDefault(msg, 206, false),
r47ShowMissionPlanners: jspb.Message.getBooleanFieldWithDefault(msg, 208, false),
rfdControllerMaxSpeedParity: jspb.Message.getBooleanFieldWithDefault(msg, 209, false),
enableArStreetOverlays: jspb.Message.getBooleanFieldWithDefault(msg, 210, false),
enableCloudUiPublicSafetyLightsV2: jspb.Message.getBooleanFieldWithDefault(msg, 212, false),
enableRfdHudCompass: jspb.Message.getBooleanFieldWithDefault(msg, 213, false),
enableFlyToPoiR47: jspb.Message.getBooleanFieldWithDefault(msg, 214, false),
enableRfdHudAirspeedAltitude: jspb.Message.getBooleanFieldWithDefault(msg, 216, false),
enableSiteWideWeatherSensorData: jspb.Message.getBooleanFieldWithDefault(msg, 217, false),
enableSiteWideAdsbData: jspb.Message.getBooleanFieldWithDefault(msg, 218, false),
enableIncidentMarkersRfd: jspb.Message.getBooleanFieldWithDefault(msg, 219, false),
moveVehicleLaunchModalVideoFeed: jspb.Message.getBooleanFieldWithDefault(msg, 220, false),
enableLookAtFinalPoint: jspb.Message.getBooleanFieldWithDefault(msg, 221, false),
enableDockTransitPoint: jspb.Message.getBooleanFieldWithDefault(msg, 222, false),
enableViewDownloadRtkPpkFiles: jspb.Message.getBooleanFieldWithDefault(msg, 224, false),
publicVisibilityDashboard: jspb.Message.getBooleanFieldWithDefault(msg, 225, false),
usePathfinderFlyToPointRfd: jspb.Message.getBooleanFieldWithDefault(msg, 227, false),
mediaAvailableForFlightAlert: jspb.Message.getBooleanFieldWithDefault(msg, 228, false),
emitRtspStreamsToDefaultEgress: jspb.Message.getBooleanFieldWithDefault(msg, 230, false),
dfrStockSettings: jspb.Message.getBooleanFieldWithDefault(msg, 232, false),
customer2CustomMapboxMapStyles: jspb.Message.getBooleanFieldWithDefault(msg, 234, false),
rfdConnectivitySettingsTab: jspb.Message.getBooleanFieldWithDefault(msg, 236, false),
missionEditorNightAutonomy: jspb.Message.getBooleanFieldWithDefault(msg, 237, false),
rfdParachuteAttachmentUi: jspb.Message.getBooleanFieldWithDefault(msg, 238, false),
showCloudSimulatorControls: jspb.Message.getBooleanFieldWithDefault(msg, 239, false),
missionSharingCustomerPortal: jspb.Message.getBooleanFieldWithDefault(msg, 240, false),
useImprovedFlightStatusWorkflow: jspb.Message.getBooleanFieldWithDefault(msg, 243, false),
enableMarkersAr: jspb.Message.getBooleanFieldWithDefault(msg, 245, false),
rfdTelemetryStats: jspb.Message.getBooleanFieldWithDefault(msg, 247, false),
showOperationsAreaInternalMapboxStyles: jspb.Message.getBooleanFieldWithDefault(msg, 248, false),
activateStrobeLightsOnLaunchRfd: jspb.Message.getBooleanFieldWithDefault(msg, 249, false),
missionDocumentsApi: jspb.Message.getBooleanFieldWithDefault(msg, 250, false),
fleetPageSdCardFormatting: jspb.Message.getBooleanFieldWithDefault(msg, 251, false),
enableMultidroneOperations: jspb.Message.getBooleanFieldWithDefault(msg, 252, false),
controlKeyDragWaypointVertical: jspb.Message.getBooleanFieldWithDefault(msg, 254, false),
showTerrainAndBldgsToggleInFleetPage: jspb.Message.getBooleanFieldWithDefault(msg, 255, false),
manageFlyToPointHeightWithVehicleOverride: jspb.Message.getBooleanFieldWithDefault(msg, 256, false),
altKeyDragWaypointVertical: jspb.Message.getBooleanFieldWithDefault(msg, 257, false),
copyMarkersBetweenNypdOrgs: jspb.Message.getBooleanFieldWithDefault(msg, 258, false),
showOverlappingDockWifiChannelsFleetPage: jspb.Message.getBooleanFieldWithDefault(msg, 259, false),
showInternalMapboxStyles3: jspb.Message.getBooleanFieldWithDefault(msg, 261, false),
fixedLocationRid: jspb.Message.getBooleanFieldWithDefault(msg, 262, false),
alertOnFlyToPointAltitudeChange: jspb.Message.getBooleanFieldWithDefault(msg, 263, false),
teleopPilotKeepAlive: jspb.Message.getBooleanFieldWithDefault(msg, 264, false),
ascendSolarMapCaptureDemo: jspb.Message.getBooleanFieldWithDefault(msg, 270, false),
useWorldTakeoffFrameFlyToPoint: jspb.Message.getBooleanFieldWithDefault(msg, 271, false),
enableRtkSupport: jspb.Message.getBooleanFieldWithDefault(msg, 272, false),
cityCustomerMapboxMapStyles: jspb.Message.getBooleanFieldWithDefault(msg, 274, false),
linkLossAlertLevelCaution: jspb.Message.getBooleanFieldWithDefault(msg, 276, false),
enableDownloadAllScanFiles: jspb.Message.getBooleanFieldWithDefault(msg, 277, false),
showAdsbStatusInRfd: jspb.Message.getBooleanFieldWithDefault(msg, 279, false),
showVioResetCloudOverride: jspb.Message.getBooleanFieldWithDefault(msg, 282, false),
enableStreamingRumEvents: jspb.Message.getBooleanFieldWithDefault(msg, 283, false),
enableStreamingDdLogs: jspb.Message.getBooleanFieldWithDefault(msg, 302, false),
disableStreamingMixpanelEvents: jspb.Message.getBooleanFieldWithDefault(msg, 421, false),
displayMediaSyncSpeedTest: jspb.Message.getBooleanFieldWithDefault(msg, 287, false),
enableSetupFlights: jspb.Message.getBooleanFieldWithDefault(msg, 288, false),
europeanUnion: jspb.Message.getBooleanFieldWithDefault(msg, 289, false),
enableEvShortcutsRfd: jspb.Message.getBooleanFieldWithDefault(msg, 290, false),
enableSettingsDevicesAccessPointUi: jspb.Message.getBooleanFieldWithDefault(msg, 291, false),
enableCreateMarkerInteractionRfd: jspb.Message.getBooleanFieldWithDefault(msg, 292, false),
dronesenseIntegrationSetup: jspb.Message.getBooleanFieldWithDefault(msg, 293, false),
sendParquetIngestorJobsToTemporal: jspb.Message.getBooleanFieldWithDefault(msg, 294, false),
enableC18MicrohardOfflineConfiguration: jspb.Message.getBooleanFieldWithDefault(msg, 295, false),
customMapLayersExternal: jspb.Message.getBooleanFieldWithDefault(msg, 296, false),
customMapLayersInternal: jspb.Message.getBooleanFieldWithDefault(msg, 297, false),
dfrCommandPhase1MarkersUi: jspb.Message.getBooleanFieldWithDefault(msg, 298, false),
enableG47DockInspectionRfd: jspb.Message.getBooleanFieldWithDefault(msg, 299, false),
disableAutomaticVideoRecording: jspb.Message.getBooleanFieldWithDefault(msg, 301, false),
filterMarkersInRfdSidebar: jspb.Message.getBooleanFieldWithDefault(msg, 303, false),
dfrCommand: jspb.Message.getBooleanFieldWithDefault(msg, 305, false),
missionDetailsAboveSkillsSwitcher: jspb.Message.getBooleanFieldWithDefault(msg, 306, false),
multiBatteryMissions: jspb.Message.getBooleanFieldWithDefault(msg, 307, false),
swapToX10DockCamOnLanding: jspb.Message.getBooleanFieldWithDefault(msg, 308, false),
enableRfdHudCompassV2: jspb.Message.getBooleanFieldWithDefault(msg, 309, false),
enableRfdDedrone: jspb.Message.getBooleanFieldWithDefault(msg, 310, false),
enableRfdAdsbRecording: jspb.Message.getBooleanFieldWithDefault(msg, 311, false),
missionEditorShowInternalNavigationModeOptions: jspb.Message.getBooleanFieldWithDefault(msg, 313, false),
enableDfrCommandPhaseTwoUi: jspb.Message.getBooleanFieldWithDefault(msg, 314, false),
enableDfrCommandPhaseTwoPointFiveUi: jspb.Message.getBooleanFieldWithDefault(msg, 315, false),
enableDfrCommandPhaseThreeUi: jspb.Message.getBooleanFieldWithDefault(msg, 316, false),
enableDfrOrgBasedLivekitRoom: jspb.Message.getBooleanFieldWithDefault(msg, 317, false),
x10DefaultsForGpsInitWaypoint: jspb.Message.getBooleanFieldWithDefault(msg, 318, false),
readyLinkSecurityPin: jspb.Message.getBooleanFieldWithDefault(msg, 319, false),
enableDockDeviceSettingsPage: jspb.Message.getBooleanFieldWithDefault(msg, 320, false),
enableMediaSyncTabOnDeviceSettingsPage: jspb.Message.getBooleanFieldWithDefault(msg, 321, false),
enableProperArSync: jspb.Message.getBooleanFieldWithDefault(msg, 324, false),
externalApiIncidentMarkersUi: jspb.Message.getBooleanFieldWithDefault(msg, 325, false),
markersAreaFilteringUi: jspb.Message.getBooleanFieldWithDefault(msg, 326, false),
markersSidebarSortingUi: jspb.Message.getBooleanFieldWithDefault(msg, 327, false),
enableRfdViewLookatPoint: jspb.Message.getBooleanFieldWithDefault(msg, 329, false),
enableRfdSetLookatPoint: jspb.Message.getBooleanFieldWithDefault(msg, 330, false),
enableVehicleDeviceSettingsPage: jspb.Message.getBooleanFieldWithDefault(msg, 331, false),
fleetFlightSystemHealth: jspb.Message.getBooleanFieldWithDefault(msg, 332, false),
simulateRemoteOnPremOrg: jspb.Message.getBooleanFieldWithDefault(msg, 333, false),
enableRfdAglAmsl: jspb.Message.getBooleanFieldWithDefault(msg, 335, false),
readyLinkSelectableStreams: jspb.Message.getBooleanFieldWithDefault(msg, 336, false),
multiOrgUsersRpic: jspb.Message.getBooleanFieldWithDefault(msg, 337, false),
markersApi: jspb.Message.getBooleanFieldWithDefault(msg, 339, false),
enablePropsHoursHealth: jspb.Message.getBooleanFieldWithDefault(msg, 340, false),
allowDirectDeviceAdoption: jspb.Message.getBooleanFieldWithDefault(msg, 342, false),
enableDocklessSites: jspb.Message.getBooleanFieldWithDefault(msg, 343, false),
enableRampHeightModeFlyToPointRfd: jspb.Message.getBooleanFieldWithDefault(msg, 344, false),
deprecateOrgInvitations: jspb.Message.getBooleanFieldWithDefault(msg, 345, false),
enableReadyLink1Point3Ui: jspb.Message.getBooleanFieldWithDefault(msg, 346, false),
enableTeleopInIframe: jspb.Message.getBooleanFieldWithDefault(msg, 347, false),
enableDfrDockviewLayout: jspb.Message.getBooleanFieldWithDefault(msg, 348, false),
enableCustomerManagedSessionLengths: jspb.Message.getBooleanFieldWithDefault(msg, 349, false),
enableStandoffDistance: jspb.Message.getBooleanFieldWithDefault(msg, 350, false),
supportUserExpiry: jspb.Message.getBooleanFieldWithDefault(msg, 351, false),
enableDispatchRespondHere: jspb.Message.getBooleanFieldWithDefault(msg, 352, false),
readyLinkMultiVehicleSelect: jspb.Message.getBooleanFieldWithDefault(msg, 354, false),
deploymentEngineerMissionsInternal: jspb.Message.getBooleanFieldWithDefault(msg, 355, false),
addApiTokensToResourceGroups: jspb.Message.getBooleanFieldWithDefault(msg, 356, false),
setTakePhotoWaitForFocusToConverge: jspb.Message.getBooleanFieldWithDefault(msg, 357, false),
cloudRel3UiUpdates: jspb.Message.getBooleanFieldWithDefault(msg, 358, false),
enableManualIncidentCreation: jspb.Message.getBooleanFieldWithDefault(msg, 359, false),
enableValidationOfOnDemandMission: jspb.Message.getBooleanFieldWithDefault(msg, 360, false),
enableAxonWatchMeDemo: jspb.Message.getBooleanFieldWithDefault(msg, 361, false),
batteryDevicePage: jspb.Message.getBooleanFieldWithDefault(msg, 362, false),
enableIncidentsStateUi: jspb.Message.getBooleanFieldWithDefault(msg, 363, false),
enablePlanningAroundGeofencesFlyToPointRfd: jspb.Message.getBooleanFieldWithDefault(msg, 364, false),
batteryFirmwareIncrement: jspb.Message.getBooleanFieldWithDefault(msg, 365, false),
cloudRel4UiUpdates: jspb.Message.getBooleanFieldWithDefault(msg, 367, false),
hiveChannelConflictPrevention: jspb.Message.getBooleanFieldWithDefault(msg, 368, false),
sortDroneSelectionModalDispatch: jspb.Message.getBooleanFieldWithDefault(msg, 369, false),
unifiedMissionEditor: jspb.Message.getBooleanFieldWithDefault(msg, 370, false),
missionsCloudToController: jspb.Message.getBooleanFieldWithDefault(msg, 371, false),
enableWaypointMetricsWorkflow: jspb.Message.getBooleanFieldWithDefault(msg, 372, false),
enablePropellerTypeSpecification: jspb.Message.getBooleanFieldWithDefault(msg, 373, false),
improvedLandingButtons: jspb.Message.getBooleanFieldWithDefault(msg, 374, false),
enableAxonSha256: jspb.Message.getBooleanFieldWithDefault(msg, 375, false),
enableCancelIncidentResponseModal: jspb.Message.getBooleanFieldWithDefault(msg, 376, false),
controllerDevicePage: jspb.Message.getBooleanFieldWithDefault(msg, 377, false),
displayCellularCarrierInfo: jspb.Message.getBooleanFieldWithDefault(msg, 378, false),
enableUnsupportedBrowserWarning: jspb.Message.getBooleanFieldWithDefault(msg, 379, false),
enableExtraAccessModes: jspb.Message.getBooleanFieldWithDefault(msg, 380, false),
enableCustomMapLayersBackend: jspb.Message.getBooleanFieldWithDefault(msg, 381, false),
enablePriorityDfrCloudIa: jspb.Message.getBooleanFieldWithDefault(msg, 382, false),
reverseGeocodeMarkersOnRead: jspb.Message.getBooleanFieldWithDefault(msg, 383, false),
editOrgFlightPolicyNondocked: jspb.Message.getBooleanFieldWithDefault(msg, 385, false),
sitesImprovements525: jspb.Message.getBooleanFieldWithDefault(msg, 387, false),
cloudRel5UiUpdates: jspb.Message.getBooleanFieldWithDefault(msg, 388, false),
showFileReleaseUi: jspb.Message.getBooleanFieldWithDefault(msg, 389, false),
useX10rev1AndUnknownAcceleratedPropWearAlert: jspb.Message.getBooleanFieldWithDefault(msg, 390, false),
useX10rev2AcceleratedPropWearAlert: jspb.Message.getBooleanFieldWithDefault(msg, 391, false),
rtkEarlyAccessProgram: jspb.Message.getBooleanFieldWithDefault(msg, 392, false),
newCloudNavigation: jspb.Message.getBooleanFieldWithDefault(msg, 393, false),
apiObservability: jspb.Message.getBooleanFieldWithDefault(msg, 394, false),
newIntegrationsUi: jspb.Message.getBooleanFieldWithDefault(msg, 395, false),
showSwIncompatibilityHealthIssue: jspb.Message.getBooleanFieldWithDefault(msg, 396, false),
updatedCreateOrganizationModal: jspb.Message.getBooleanFieldWithDefault(msg, 397, false),
cloudSimAutomaticSiteSetup: jspb.Message.getBooleanFieldWithDefault(msg, 398, false),
readyLinkViewerCountPoll: jspb.Message.getBooleanFieldWithDefault(msg, 399, false),
sensorPackageDetailsEnabledUi: jspb.Message.getBooleanFieldWithDefault(msg, 401, false),
enablePostFlightReports: jspb.Message.getBooleanFieldWithDefault(msg, 402, false),
arGoalAsStandoffIndicator: jspb.Message.getBooleanFieldWithDefault(msg, 404, false),
showAttachmentDetailsInCustomerPortal: jspb.Message.getBooleanFieldWithDefault(msg, 405, false),
enableDfrOutcomesSurvey: jspb.Message.getBooleanFieldWithDefault(msg, 406, false),
rfdStreamlineNotifications: jspb.Message.getBooleanFieldWithDefault(msg, 407, false),
filterMarkerButtonInSidebar: jspb.Message.getBooleanFieldWithDefault(msg, 408, false),
enableBatteryFrettingAlerts: jspb.Message.getBooleanFieldWithDefault(msg, 409, false),
enableDistributionList: jspb.Message.getBooleanFieldWithDefault(msg, 410, false),
includeCaseIdsInAxonEvidenceTitle: jspb.Message.getBooleanFieldWithDefault(msg, 411, false),
showInternalFlightDeckCommands: jspb.Message.getBooleanFieldWithDefault(msg, 412, false),
showDrawerSidebar: jspb.Message.getBooleanFieldWithDefault(msg, 413, false),
turboReduxBridge: jspb.Message.getBooleanFieldWithDefault(msg, 414, false),
useNewFlashpackChannels: jspb.Message.getBooleanFieldWithDefault(msg, 415, false),
disableEmailLogins: jspb.Message.getBooleanFieldWithDefault(msg, 416, false),
enableFususCadPoller: jspb.Message.getBooleanFieldWithDefault(msg, 417, false),
cloudRel6UiUpdates: jspb.Message.getBooleanFieldWithDefault(msg, 418, false),
cloudRel7UiUpdates: jspb.Message.getBooleanFieldWithDefault(msg, 419, false),
multipleMediaSyncPolicies: jspb.Message.getBooleanFieldWithDefault(msg, 420, false),
showA22DetailsInUi: jspb.Message.getBooleanFieldWithDefault(msg, 422, false),
otherDevicePage: jspb.Message.getBooleanFieldWithDefault(msg, 423, false),
subjectTracking: jspb.Message.getBooleanFieldWithDefault(msg, 424, false),
assetInspectionMissionPlanningV0: jspb.Message.getBooleanFieldWithDefault(msg, 425, false),
enablePreFlightChecklists: jspb.Message.getBooleanFieldWithDefault(msg, 426, false),
brandingDfrCommand: jspb.Message.getBooleanFieldWithDefault(msg, 427, false),
showCellularConfigs: jspb.Message.getBooleanFieldWithDefault(msg, 428, false),
enableSurfaceScanSkillTeleop: jspb.Message.getBooleanFieldWithDefault(msg, 429, false),
autonomyWidgetRfd: jspb.Message.getBooleanFieldWithDefault(msg, 430, false),
showPropellerHoursTrackingOverrideSetting: jspb.Message.getBooleanFieldWithDefault(msg, 431, false),
dockComputeReplacement: jspb.Message.getBooleanFieldWithDefault(msg, 432, false),
enableCreateStubFlightWorkflow: jspb.Message.getBooleanFieldWithDefault(msg, 433, false),
axonGlobalRegion: jspb.Message.getBooleanFieldWithDefault(msg, 434, false),
allowScanPlaneOffsetForMapCapture: jspb.Message.getBooleanFieldWithDefault(msg, 435, false),
rtkPpkRfdTelemetry: jspb.Message.getBooleanFieldWithDefault(msg, 436, false),
subjectTrackingForEngineering: jspb.Message.getBooleanFieldWithDefault(msg, 437, false),
prepared911Integration: jspb.Message.getBooleanFieldWithDefault(msg, 438, false),
enableMultidroneAscendFy26: jspb.Message.getBooleanFieldWithDefault(msg, 440, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud_api.FeatureFlags}
 */
proto.cloud_api.FeatureFlags.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud_api.FeatureFlags;
  return proto.cloud_api.FeatureFlags.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud_api.FeatureFlags} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud_api.FeatureFlags}
 */
proto.cloud_api.FeatureFlags.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVehicleTeleoperation(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAutomaticFileUploadPage(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVehicleLicensesPage(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLiveStreaming(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAxonMediaIntegration(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMissionsPage(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVehicleRemoteStreaming(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMobileRemoteStreaming(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMultiViewerStreaming(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAxonRespondIntegration(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setViewOfflineSettings(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setConfigureObstacleMargin(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDroInternal(value);
      break;
    case 21:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAnnotations(value);
      break;
    case 22:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCloudInspectPage(value);
      break;
    case 23:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMissionMediaViewer(value);
      break;
    case 26:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAutomaticCloudPhotogrammetry(value);
      break;
    case 27:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDockLocationUpdate(value);
      break;
    case 29:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisableTeleopLandingPrompt(value);
      break;
    case 31:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDroTeleopRunMissionJson(value);
      break;
    case 33:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHideLandNowDuringRtd(value);
      break;
    case 36:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRemoteVideoApiAccess(value);
      break;
    case 38:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowTwilightFlight(value);
      break;
    case 39:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowBacktrackingRtx(value);
      break;
    case 40:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCloudOta(value);
      break;
    case 41:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTeleopDebugMenu(value);
      break;
    case 42:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setQosSkybusChannelSetting(value);
      break;
    case 43:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPostRefactorMissionEditor(value);
      break;
    case 46:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNetworkDebuggingTools(value);
      break;
    case 47:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFullHeightVideoEnabled(value);
      break;
    case 49:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNavHeightAboveGroundEnabled(value);
      break;
    case 51:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInternalThemeToggle(value);
      break;
    case 53:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCustomerCustomMapboxMapStyles(value);
      break;
    case 63:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowVehicleFaultsTeleop(value);
      break;
    case 66:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowVpsInfo(value);
      break;
    case 67:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTeleopArV2(value);
      break;
    case 68:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMissionControlApi(value);
      break;
    case 69:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setScheduleMissionNowApi(value);
      break;
    case 71:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSurfaceScanMissions(value);
      break;
    case 72:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowAprilTagSettings(value);
      break;
    case 73:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowSkydioLinkSettings(value);
      break;
    case 76:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWhatsNew(value);
      break;
    case 80:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowRangeLimitSettings(value);
      break;
    case 85:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSiteMapper(value);
      break;
    case 86:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowBandSelectionSettings(value);
      break;
    case 87:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFlyNowNoAutomaticRunModeSwitching(value);
      break;
    case 88:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setArVideoSync(value);
      break;
    case 89:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMissionResults3dViewer(value);
      break;
    case 92:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAutomaticNcpgPhotogrammetry(value);
      break;
    case 93:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExecutiveActionHotkeys(value);
      break;
    case 94:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVehicleTypeBasedAxonSessions(value);
      break;
    case 98:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSiteMissions(value);
      break;
    case 99:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAlwaysShowCameraSettings(value);
      break;
    case 101:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTeleopWaypointCommands(value);
      break;
    case 105:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDroRemoteId(value);
      break;
    case 108:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPropGuardsEnablement(value);
      break;
    case 111:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRemotePilotApiAccess(value);
      break;
    case 112:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowViewFlightDeckButton(value);
      break;
    case 113:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTwilightModeFastFlight(value);
      break;
    case 114:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStandaloneMapPage(value);
      break;
    case 115:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMissionResume(value);
      break;
    case 116:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLostCommsTimeoutSettingTeleop(value);
      break;
    case 117:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTeleopFastFlight(value);
      break;
    case 119:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowEditAdsbSettings(value);
      break;
    case 121:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowTeleopIdleModal(value);
      break;
    case 122:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSkydioExtend(value);
      break;
    case 123:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSupportMenuV2(value);
      break;
    case 125:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGeofenceEnforcementInCloud(value);
      break;
    case 126:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSensorDataViewClaim(value);
      break;
    case 129:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTeleopThirdPersonView(value);
      break;
    case 132:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowTeleopCircularBatteryWidget(value);
      break;
    case 133:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAlertManagerWithAudioInTeleop(value);
      break;
    case 134:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStructureAnnotationsApi(value);
      break;
    case 135:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMoveLivestreamTagPosition(value);
      break;
    case 136:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowActivePilotNameIfLivestreaming(value);
      break;
    case 137:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMoveShareLivestreamButtonToIcon(value);
      break;
    case 138:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOwnOrgGroups(value);
      break;
    case 139:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTeleopCommandeeringV2(value);
      break;
    case 140:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMediaAvailableAlert(value);
      break;
    case 141:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMediaAvailableForScanAlert(value);
      break;
    case 142:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNcpgPhotogrammetryUseTensorRtFlowModel(value);
      break;
    case 143:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowFaaMapboxStyles(value);
      break;
    case 144:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowSchedulingR47Missions(value);
      break;
    case 147:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSitesStructureEditor(value);
      break;
    case 148:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMultiMissionFlightTester(value);
      break;
    case 153:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTeleopSettingsModalV3(value);
      break;
    case 154:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setX10EoCameraControlsParityInTeleop(value);
      break;
    case 155:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNoObstacleAvoidanceInTeleop(value);
      break;
    case 158:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLiveMissionPlanning(value);
      break;
    case 161:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWaypointCameraSettings(value);
      break;
    case 162:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVpsMapDatamodelTransitionReadFromNew(value);
      break;
    case 163:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVpsMapDatamodelTransitionWriteToBoth(value);
      break;
    case 164:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEditOrgFlightPolicy(value);
      break;
    case 165:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTeleopWheelZoom(value);
      break;
    case 166:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMultizoneSiteGeofences(value);
      break;
    case 168:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTeleopBitrateSlider(value);
      break;
    case 169:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setX10ZoomAndFlashUi(value);
      break;
    case 171:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRidFeatureDisabled(value);
      break;
    case 173:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRemoveFlightFromResourceGroup(value);
      break;
    case 174:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSafeLandingPoints(value);
      break;
    case 177:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTeleopBoostMode(value);
      break;
    case 178:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTeleopCrawlMode(value);
      break;
    case 179:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableFlyToPoiRfd(value);
      break;
    case 180:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowOperationsAreaMapboxStyles(value);
      break;
    case 183:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBarometerHeightMode(value);
      break;
    case 186:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGraphiqlViewer(value);
      break;
    case 187:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableOrbitToPoiRfd(value);
      break;
    case 188:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisableCloudConfigSignatureVerification(value);
      break;
    case 189:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsOnpremOrg(value);
      break;
    case 190:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnablePointerLockDuringMissionsRfd(value);
      break;
    case 192:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableMapVehicleFollowiing(value);
      break;
    case 193:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReadyLinkSingleVehicle(value);
      break;
    case 194:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTeleopTelemetryHeadingAndGimbalPitch(value);
      break;
    case 195:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMediaPageKindDropdown(value);
      break;
    case 196:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTeleopActionsToolbar(value);
      break;
    case 199:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableDockLandingAr(value);
      break;
    case 201:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTeleopNavSourceInfoHealth(value);
      break;
    case 202:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableAxonMarkersRfd(value);
      break;
    case 203:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableFpvOnMap(value);
      break;
    case 204:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOfflineUpdatesPage(value);
      break;
    case 206:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGimbalPitchResetShortcut(value);
      break;
    case 208:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setR47ShowMissionPlanners(value);
      break;
    case 209:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRfdControllerMaxSpeedParity(value);
      break;
    case 210:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableArStreetOverlays(value);
      break;
    case 212:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableCloudUiPublicSafetyLightsV2(value);
      break;
    case 213:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableRfdHudCompass(value);
      break;
    case 214:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableFlyToPoiR47(value);
      break;
    case 216:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableRfdHudAirspeedAltitude(value);
      break;
    case 217:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableSiteWideWeatherSensorData(value);
      break;
    case 218:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableSiteWideAdsbData(value);
      break;
    case 219:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableIncidentMarkersRfd(value);
      break;
    case 220:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMoveVehicleLaunchModalVideoFeed(value);
      break;
    case 221:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableLookAtFinalPoint(value);
      break;
    case 222:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableDockTransitPoint(value);
      break;
    case 224:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableViewDownloadRtkPpkFiles(value);
      break;
    case 225:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPublicVisibilityDashboard(value);
      break;
    case 227:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUsePathfinderFlyToPointRfd(value);
      break;
    case 228:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMediaAvailableForFlightAlert(value);
      break;
    case 230:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEmitRtspStreamsToDefaultEgress(value);
      break;
    case 232:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDfrStockSettings(value);
      break;
    case 234:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCustomer2CustomMapboxMapStyles(value);
      break;
    case 236:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRfdConnectivitySettingsTab(value);
      break;
    case 237:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMissionEditorNightAutonomy(value);
      break;
    case 238:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRfdParachuteAttachmentUi(value);
      break;
    case 239:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowCloudSimulatorControls(value);
      break;
    case 240:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMissionSharingCustomerPortal(value);
      break;
    case 243:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseImprovedFlightStatusWorkflow(value);
      break;
    case 245:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableMarkersAr(value);
      break;
    case 247:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRfdTelemetryStats(value);
      break;
    case 248:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowOperationsAreaInternalMapboxStyles(value);
      break;
    case 249:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActivateStrobeLightsOnLaunchRfd(value);
      break;
    case 250:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMissionDocumentsApi(value);
      break;
    case 251:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFleetPageSdCardFormatting(value);
      break;
    case 252:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableMultidroneOperations(value);
      break;
    case 254:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setControlKeyDragWaypointVertical(value);
      break;
    case 255:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowTerrainAndBldgsToggleInFleetPage(value);
      break;
    case 256:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setManageFlyToPointHeightWithVehicleOverride(value);
      break;
    case 257:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAltKeyDragWaypointVertical(value);
      break;
    case 258:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCopyMarkersBetweenNypdOrgs(value);
      break;
    case 259:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowOverlappingDockWifiChannelsFleetPage(value);
      break;
    case 261:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowInternalMapboxStyles3(value);
      break;
    case 262:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFixedLocationRid(value);
      break;
    case 263:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAlertOnFlyToPointAltitudeChange(value);
      break;
    case 264:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTeleopPilotKeepAlive(value);
      break;
    case 270:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAscendSolarMapCaptureDemo(value);
      break;
    case 271:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseWorldTakeoffFrameFlyToPoint(value);
      break;
    case 272:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableRtkSupport(value);
      break;
    case 274:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCityCustomerMapboxMapStyles(value);
      break;
    case 276:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLinkLossAlertLevelCaution(value);
      break;
    case 277:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableDownloadAllScanFiles(value);
      break;
    case 279:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowAdsbStatusInRfd(value);
      break;
    case 282:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowVioResetCloudOverride(value);
      break;
    case 283:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableStreamingRumEvents(value);
      break;
    case 302:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableStreamingDdLogs(value);
      break;
    case 421:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisableStreamingMixpanelEvents(value);
      break;
    case 287:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisplayMediaSyncSpeedTest(value);
      break;
    case 288:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableSetupFlights(value);
      break;
    case 289:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEuropeanUnion(value);
      break;
    case 290:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableEvShortcutsRfd(value);
      break;
    case 291:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableSettingsDevicesAccessPointUi(value);
      break;
    case 292:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableCreateMarkerInteractionRfd(value);
      break;
    case 293:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDronesenseIntegrationSetup(value);
      break;
    case 294:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSendParquetIngestorJobsToTemporal(value);
      break;
    case 295:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableC18MicrohardOfflineConfiguration(value);
      break;
    case 296:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCustomMapLayersExternal(value);
      break;
    case 297:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCustomMapLayersInternal(value);
      break;
    case 298:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDfrCommandPhase1MarkersUi(value);
      break;
    case 299:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableG47DockInspectionRfd(value);
      break;
    case 301:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisableAutomaticVideoRecording(value);
      break;
    case 303:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFilterMarkersInRfdSidebar(value);
      break;
    case 305:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDfrCommand(value);
      break;
    case 306:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMissionDetailsAboveSkillsSwitcher(value);
      break;
    case 307:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMultiBatteryMissions(value);
      break;
    case 308:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSwapToX10DockCamOnLanding(value);
      break;
    case 309:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableRfdHudCompassV2(value);
      break;
    case 310:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableRfdDedrone(value);
      break;
    case 311:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableRfdAdsbRecording(value);
      break;
    case 313:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMissionEditorShowInternalNavigationModeOptions(value);
      break;
    case 314:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableDfrCommandPhaseTwoUi(value);
      break;
    case 315:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableDfrCommandPhaseTwoPointFiveUi(value);
      break;
    case 316:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableDfrCommandPhaseThreeUi(value);
      break;
    case 317:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableDfrOrgBasedLivekitRoom(value);
      break;
    case 318:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setX10DefaultsForGpsInitWaypoint(value);
      break;
    case 319:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReadyLinkSecurityPin(value);
      break;
    case 320:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableDockDeviceSettingsPage(value);
      break;
    case 321:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableMediaSyncTabOnDeviceSettingsPage(value);
      break;
    case 324:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableProperArSync(value);
      break;
    case 325:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExternalApiIncidentMarkersUi(value);
      break;
    case 326:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMarkersAreaFilteringUi(value);
      break;
    case 327:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMarkersSidebarSortingUi(value);
      break;
    case 329:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableRfdViewLookatPoint(value);
      break;
    case 330:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableRfdSetLookatPoint(value);
      break;
    case 331:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableVehicleDeviceSettingsPage(value);
      break;
    case 332:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFleetFlightSystemHealth(value);
      break;
    case 333:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSimulateRemoteOnPremOrg(value);
      break;
    case 335:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableRfdAglAmsl(value);
      break;
    case 336:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReadyLinkSelectableStreams(value);
      break;
    case 337:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMultiOrgUsersRpic(value);
      break;
    case 339:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMarkersApi(value);
      break;
    case 340:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnablePropsHoursHealth(value);
      break;
    case 342:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowDirectDeviceAdoption(value);
      break;
    case 343:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableDocklessSites(value);
      break;
    case 344:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableRampHeightModeFlyToPointRfd(value);
      break;
    case 345:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDeprecateOrgInvitations(value);
      break;
    case 346:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableReadyLink1Point3Ui(value);
      break;
    case 347:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableTeleopInIframe(value);
      break;
    case 348:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableDfrDockviewLayout(value);
      break;
    case 349:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableCustomerManagedSessionLengths(value);
      break;
    case 350:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableStandoffDistance(value);
      break;
    case 351:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSupportUserExpiry(value);
      break;
    case 352:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableDispatchRespondHere(value);
      break;
    case 354:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReadyLinkMultiVehicleSelect(value);
      break;
    case 355:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDeploymentEngineerMissionsInternal(value);
      break;
    case 356:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAddApiTokensToResourceGroups(value);
      break;
    case 357:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSetTakePhotoWaitForFocusToConverge(value);
      break;
    case 358:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCloudRel3UiUpdates(value);
      break;
    case 359:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableManualIncidentCreation(value);
      break;
    case 360:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableValidationOfOnDemandMission(value);
      break;
    case 361:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableAxonWatchMeDemo(value);
      break;
    case 362:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBatteryDevicePage(value);
      break;
    case 363:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableIncidentsStateUi(value);
      break;
    case 364:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnablePlanningAroundGeofencesFlyToPointRfd(value);
      break;
    case 365:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBatteryFirmwareIncrement(value);
      break;
    case 367:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCloudRel4UiUpdates(value);
      break;
    case 368:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHiveChannelConflictPrevention(value);
      break;
    case 369:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSortDroneSelectionModalDispatch(value);
      break;
    case 370:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUnifiedMissionEditor(value);
      break;
    case 371:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMissionsCloudToController(value);
      break;
    case 372:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableWaypointMetricsWorkflow(value);
      break;
    case 373:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnablePropellerTypeSpecification(value);
      break;
    case 374:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setImprovedLandingButtons(value);
      break;
    case 375:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableAxonSha256(value);
      break;
    case 376:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableCancelIncidentResponseModal(value);
      break;
    case 377:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setControllerDevicePage(value);
      break;
    case 378:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisplayCellularCarrierInfo(value);
      break;
    case 379:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableUnsupportedBrowserWarning(value);
      break;
    case 380:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableExtraAccessModes(value);
      break;
    case 381:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableCustomMapLayersBackend(value);
      break;
    case 382:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnablePriorityDfrCloudIa(value);
      break;
    case 383:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReverseGeocodeMarkersOnRead(value);
      break;
    case 385:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEditOrgFlightPolicyNondocked(value);
      break;
    case 387:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSitesImprovements525(value);
      break;
    case 388:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCloudRel5UiUpdates(value);
      break;
    case 389:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowFileReleaseUi(value);
      break;
    case 390:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseX10rev1AndUnknownAcceleratedPropWearAlert(value);
      break;
    case 391:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseX10rev2AcceleratedPropWearAlert(value);
      break;
    case 392:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRtkEarlyAccessProgram(value);
      break;
    case 393:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNewCloudNavigation(value);
      break;
    case 394:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setApiObservability(value);
      break;
    case 395:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNewIntegrationsUi(value);
      break;
    case 396:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowSwIncompatibilityHealthIssue(value);
      break;
    case 397:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUpdatedCreateOrganizationModal(value);
      break;
    case 398:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCloudSimAutomaticSiteSetup(value);
      break;
    case 399:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReadyLinkViewerCountPoll(value);
      break;
    case 401:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSensorPackageDetailsEnabledUi(value);
      break;
    case 402:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnablePostFlightReports(value);
      break;
    case 404:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setArGoalAsStandoffIndicator(value);
      break;
    case 405:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowAttachmentDetailsInCustomerPortal(value);
      break;
    case 406:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableDfrOutcomesSurvey(value);
      break;
    case 407:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRfdStreamlineNotifications(value);
      break;
    case 408:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFilterMarkerButtonInSidebar(value);
      break;
    case 409:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableBatteryFrettingAlerts(value);
      break;
    case 410:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableDistributionList(value);
      break;
    case 411:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeCaseIdsInAxonEvidenceTitle(value);
      break;
    case 412:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowInternalFlightDeckCommands(value);
      break;
    case 413:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowDrawerSidebar(value);
      break;
    case 414:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTurboReduxBridge(value);
      break;
    case 415:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseNewFlashpackChannels(value);
      break;
    case 416:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisableEmailLogins(value);
      break;
    case 417:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableFususCadPoller(value);
      break;
    case 418:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCloudRel6UiUpdates(value);
      break;
    case 419:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCloudRel7UiUpdates(value);
      break;
    case 420:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMultipleMediaSyncPolicies(value);
      break;
    case 422:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowA22DetailsInUi(value);
      break;
    case 423:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOtherDevicePage(value);
      break;
    case 424:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSubjectTracking(value);
      break;
    case 425:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAssetInspectionMissionPlanningV0(value);
      break;
    case 426:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnablePreFlightChecklists(value);
      break;
    case 427:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBrandingDfrCommand(value);
      break;
    case 428:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowCellularConfigs(value);
      break;
    case 429:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableSurfaceScanSkillTeleop(value);
      break;
    case 430:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAutonomyWidgetRfd(value);
      break;
    case 431:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowPropellerHoursTrackingOverrideSetting(value);
      break;
    case 432:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDockComputeReplacement(value);
      break;
    case 433:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableCreateStubFlightWorkflow(value);
      break;
    case 434:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAxonGlobalRegion(value);
      break;
    case 435:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowScanPlaneOffsetForMapCapture(value);
      break;
    case 436:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRtkPpkRfdTelemetry(value);
      break;
    case 437:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSubjectTrackingForEngineering(value);
      break;
    case 438:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPrepared911Integration(value);
      break;
    case 440:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableMultidroneAscendFy26(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud_api.FeatureFlags.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud_api.FeatureFlags.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud_api.FeatureFlags} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.FeatureFlags.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVehicleTeleoperation();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getAutomaticFileUploadPage();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getVehicleLicensesPage();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getLiveStreaming();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getAxonMediaIntegration();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getMissionsPage();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getVehicleRemoteStreaming();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getMobileRemoteStreaming();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getMultiViewerStreaming();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getAxonRespondIntegration();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getViewOfflineSettings();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getConfigureObstacleMargin();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getDroInternal();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
  f = message.getAnnotations();
  if (f) {
    writer.writeBool(
      21,
      f
    );
  }
  f = message.getCloudInspectPage();
  if (f) {
    writer.writeBool(
      22,
      f
    );
  }
  f = message.getMissionMediaViewer();
  if (f) {
    writer.writeBool(
      23,
      f
    );
  }
  f = message.getAutomaticCloudPhotogrammetry();
  if (f) {
    writer.writeBool(
      26,
      f
    );
  }
  f = message.getDockLocationUpdate();
  if (f) {
    writer.writeBool(
      27,
      f
    );
  }
  f = message.getDisableTeleopLandingPrompt();
  if (f) {
    writer.writeBool(
      29,
      f
    );
  }
  f = message.getDroTeleopRunMissionJson();
  if (f) {
    writer.writeBool(
      31,
      f
    );
  }
  f = message.getHideLandNowDuringRtd();
  if (f) {
    writer.writeBool(
      33,
      f
    );
  }
  f = message.getRemoteVideoApiAccess();
  if (f) {
    writer.writeBool(
      36,
      f
    );
  }
  f = message.getAllowTwilightFlight();
  if (f) {
    writer.writeBool(
      38,
      f
    );
  }
  f = message.getAllowBacktrackingRtx();
  if (f) {
    writer.writeBool(
      39,
      f
    );
  }
  f = message.getCloudOta();
  if (f) {
    writer.writeBool(
      40,
      f
    );
  }
  f = message.getTeleopDebugMenu();
  if (f) {
    writer.writeBool(
      41,
      f
    );
  }
  f = message.getQosSkybusChannelSetting();
  if (f) {
    writer.writeBool(
      42,
      f
    );
  }
  f = message.getPostRefactorMissionEditor();
  if (f) {
    writer.writeBool(
      43,
      f
    );
  }
  f = message.getNetworkDebuggingTools();
  if (f) {
    writer.writeBool(
      46,
      f
    );
  }
  f = message.getFullHeightVideoEnabled();
  if (f) {
    writer.writeBool(
      47,
      f
    );
  }
  f = message.getNavHeightAboveGroundEnabled();
  if (f) {
    writer.writeBool(
      49,
      f
    );
  }
  f = message.getInternalThemeToggle();
  if (f) {
    writer.writeBool(
      51,
      f
    );
  }
  f = message.getCustomerCustomMapboxMapStyles();
  if (f) {
    writer.writeBool(
      53,
      f
    );
  }
  f = message.getShowVehicleFaultsTeleop();
  if (f) {
    writer.writeBool(
      63,
      f
    );
  }
  f = message.getShowVpsInfo();
  if (f) {
    writer.writeBool(
      66,
      f
    );
  }
  f = message.getTeleopArV2();
  if (f) {
    writer.writeBool(
      67,
      f
    );
  }
  f = message.getMissionControlApi();
  if (f) {
    writer.writeBool(
      68,
      f
    );
  }
  f = message.getScheduleMissionNowApi();
  if (f) {
    writer.writeBool(
      69,
      f
    );
  }
  f = message.getSurfaceScanMissions();
  if (f) {
    writer.writeBool(
      71,
      f
    );
  }
  f = message.getShowAprilTagSettings();
  if (f) {
    writer.writeBool(
      72,
      f
    );
  }
  f = message.getShowSkydioLinkSettings();
  if (f) {
    writer.writeBool(
      73,
      f
    );
  }
  f = message.getWhatsNew();
  if (f) {
    writer.writeBool(
      76,
      f
    );
  }
  f = message.getShowRangeLimitSettings();
  if (f) {
    writer.writeBool(
      80,
      f
    );
  }
  f = message.getSiteMapper();
  if (f) {
    writer.writeBool(
      85,
      f
    );
  }
  f = message.getShowBandSelectionSettings();
  if (f) {
    writer.writeBool(
      86,
      f
    );
  }
  f = message.getFlyNowNoAutomaticRunModeSwitching();
  if (f) {
    writer.writeBool(
      87,
      f
    );
  }
  f = message.getArVideoSync();
  if (f) {
    writer.writeBool(
      88,
      f
    );
  }
  f = message.getMissionResults3dViewer();
  if (f) {
    writer.writeBool(
      89,
      f
    );
  }
  f = message.getAutomaticNcpgPhotogrammetry();
  if (f) {
    writer.writeBool(
      92,
      f
    );
  }
  f = message.getExecutiveActionHotkeys();
  if (f) {
    writer.writeBool(
      93,
      f
    );
  }
  f = message.getVehicleTypeBasedAxonSessions();
  if (f) {
    writer.writeBool(
      94,
      f
    );
  }
  f = message.getSiteMissions();
  if (f) {
    writer.writeBool(
      98,
      f
    );
  }
  f = message.getAlwaysShowCameraSettings();
  if (f) {
    writer.writeBool(
      99,
      f
    );
  }
  f = message.getTeleopWaypointCommands();
  if (f) {
    writer.writeBool(
      101,
      f
    );
  }
  f = message.getDroRemoteId();
  if (f) {
    writer.writeBool(
      105,
      f
    );
  }
  f = message.getPropGuardsEnablement();
  if (f) {
    writer.writeBool(
      108,
      f
    );
  }
  f = message.getRemotePilotApiAccess();
  if (f) {
    writer.writeBool(
      111,
      f
    );
  }
  f = message.getShowViewFlightDeckButton();
  if (f) {
    writer.writeBool(
      112,
      f
    );
  }
  f = message.getTwilightModeFastFlight();
  if (f) {
    writer.writeBool(
      113,
      f
    );
  }
  f = message.getStandaloneMapPage();
  if (f) {
    writer.writeBool(
      114,
      f
    );
  }
  f = message.getMissionResume();
  if (f) {
    writer.writeBool(
      115,
      f
    );
  }
  f = message.getLostCommsTimeoutSettingTeleop();
  if (f) {
    writer.writeBool(
      116,
      f
    );
  }
  f = message.getTeleopFastFlight();
  if (f) {
    writer.writeBool(
      117,
      f
    );
  }
  f = message.getAllowEditAdsbSettings();
  if (f) {
    writer.writeBool(
      119,
      f
    );
  }
  f = message.getShowTeleopIdleModal();
  if (f) {
    writer.writeBool(
      121,
      f
    );
  }
  f = message.getSkydioExtend();
  if (f) {
    writer.writeBool(
      122,
      f
    );
  }
  f = message.getSupportMenuV2();
  if (f) {
    writer.writeBool(
      123,
      f
    );
  }
  f = message.getGeofenceEnforcementInCloud();
  if (f) {
    writer.writeBool(
      125,
      f
    );
  }
  f = message.getSensorDataViewClaim();
  if (f) {
    writer.writeBool(
      126,
      f
    );
  }
  f = message.getTeleopThirdPersonView();
  if (f) {
    writer.writeBool(
      129,
      f
    );
  }
  f = message.getShowTeleopCircularBatteryWidget();
  if (f) {
    writer.writeBool(
      132,
      f
    );
  }
  f = message.getAlertManagerWithAudioInTeleop();
  if (f) {
    writer.writeBool(
      133,
      f
    );
  }
  f = message.getStructureAnnotationsApi();
  if (f) {
    writer.writeBool(
      134,
      f
    );
  }
  f = message.getMoveLivestreamTagPosition();
  if (f) {
    writer.writeBool(
      135,
      f
    );
  }
  f = message.getShowActivePilotNameIfLivestreaming();
  if (f) {
    writer.writeBool(
      136,
      f
    );
  }
  f = message.getMoveShareLivestreamButtonToIcon();
  if (f) {
    writer.writeBool(
      137,
      f
    );
  }
  f = message.getOwnOrgGroups();
  if (f) {
    writer.writeBool(
      138,
      f
    );
  }
  f = message.getTeleopCommandeeringV2();
  if (f) {
    writer.writeBool(
      139,
      f
    );
  }
  f = message.getMediaAvailableAlert();
  if (f) {
    writer.writeBool(
      140,
      f
    );
  }
  f = message.getMediaAvailableForScanAlert();
  if (f) {
    writer.writeBool(
      141,
      f
    );
  }
  f = message.getNcpgPhotogrammetryUseTensorRtFlowModel();
  if (f) {
    writer.writeBool(
      142,
      f
    );
  }
  f = message.getShowFaaMapboxStyles();
  if (f) {
    writer.writeBool(
      143,
      f
    );
  }
  f = message.getAllowSchedulingR47Missions();
  if (f) {
    writer.writeBool(
      144,
      f
    );
  }
  f = message.getSitesStructureEditor();
  if (f) {
    writer.writeBool(
      147,
      f
    );
  }
  f = message.getMultiMissionFlightTester();
  if (f) {
    writer.writeBool(
      148,
      f
    );
  }
  f = message.getTeleopSettingsModalV3();
  if (f) {
    writer.writeBool(
      153,
      f
    );
  }
  f = message.getX10EoCameraControlsParityInTeleop();
  if (f) {
    writer.writeBool(
      154,
      f
    );
  }
  f = message.getNoObstacleAvoidanceInTeleop();
  if (f) {
    writer.writeBool(
      155,
      f
    );
  }
  f = message.getLiveMissionPlanning();
  if (f) {
    writer.writeBool(
      158,
      f
    );
  }
  f = message.getWaypointCameraSettings();
  if (f) {
    writer.writeBool(
      161,
      f
    );
  }
  f = message.getVpsMapDatamodelTransitionReadFromNew();
  if (f) {
    writer.writeBool(
      162,
      f
    );
  }
  f = message.getVpsMapDatamodelTransitionWriteToBoth();
  if (f) {
    writer.writeBool(
      163,
      f
    );
  }
  f = message.getEditOrgFlightPolicy();
  if (f) {
    writer.writeBool(
      164,
      f
    );
  }
  f = message.getTeleopWheelZoom();
  if (f) {
    writer.writeBool(
      165,
      f
    );
  }
  f = message.getMultizoneSiteGeofences();
  if (f) {
    writer.writeBool(
      166,
      f
    );
  }
  f = message.getTeleopBitrateSlider();
  if (f) {
    writer.writeBool(
      168,
      f
    );
  }
  f = message.getX10ZoomAndFlashUi();
  if (f) {
    writer.writeBool(
      169,
      f
    );
  }
  f = message.getRidFeatureDisabled();
  if (f) {
    writer.writeBool(
      171,
      f
    );
  }
  f = message.getRemoveFlightFromResourceGroup();
  if (f) {
    writer.writeBool(
      173,
      f
    );
  }
  f = message.getSafeLandingPoints();
  if (f) {
    writer.writeBool(
      174,
      f
    );
  }
  f = message.getTeleopBoostMode();
  if (f) {
    writer.writeBool(
      177,
      f
    );
  }
  f = message.getTeleopCrawlMode();
  if (f) {
    writer.writeBool(
      178,
      f
    );
  }
  f = message.getEnableFlyToPoiRfd();
  if (f) {
    writer.writeBool(
      179,
      f
    );
  }
  f = message.getShowOperationsAreaMapboxStyles();
  if (f) {
    writer.writeBool(
      180,
      f
    );
  }
  f = message.getBarometerHeightMode();
  if (f) {
    writer.writeBool(
      183,
      f
    );
  }
  f = message.getGraphiqlViewer();
  if (f) {
    writer.writeBool(
      186,
      f
    );
  }
  f = message.getEnableOrbitToPoiRfd();
  if (f) {
    writer.writeBool(
      187,
      f
    );
  }
  f = message.getDisableCloudConfigSignatureVerification();
  if (f) {
    writer.writeBool(
      188,
      f
    );
  }
  f = message.getIsOnpremOrg();
  if (f) {
    writer.writeBool(
      189,
      f
    );
  }
  f = message.getEnablePointerLockDuringMissionsRfd();
  if (f) {
    writer.writeBool(
      190,
      f
    );
  }
  f = message.getEnableMapVehicleFollowiing();
  if (f) {
    writer.writeBool(
      192,
      f
    );
  }
  f = message.getReadyLinkSingleVehicle();
  if (f) {
    writer.writeBool(
      193,
      f
    );
  }
  f = message.getTeleopTelemetryHeadingAndGimbalPitch();
  if (f) {
    writer.writeBool(
      194,
      f
    );
  }
  f = message.getMediaPageKindDropdown();
  if (f) {
    writer.writeBool(
      195,
      f
    );
  }
  f = message.getTeleopActionsToolbar();
  if (f) {
    writer.writeBool(
      196,
      f
    );
  }
  f = message.getEnableDockLandingAr();
  if (f) {
    writer.writeBool(
      199,
      f
    );
  }
  f = message.getTeleopNavSourceInfoHealth();
  if (f) {
    writer.writeBool(
      201,
      f
    );
  }
  f = message.getEnableAxonMarkersRfd();
  if (f) {
    writer.writeBool(
      202,
      f
    );
  }
  f = message.getEnableFpvOnMap();
  if (f) {
    writer.writeBool(
      203,
      f
    );
  }
  f = message.getOfflineUpdatesPage();
  if (f) {
    writer.writeBool(
      204,
      f
    );
  }
  f = message.getGimbalPitchResetShortcut();
  if (f) {
    writer.writeBool(
      206,
      f
    );
  }
  f = message.getR47ShowMissionPlanners();
  if (f) {
    writer.writeBool(
      208,
      f
    );
  }
  f = message.getRfdControllerMaxSpeedParity();
  if (f) {
    writer.writeBool(
      209,
      f
    );
  }
  f = message.getEnableArStreetOverlays();
  if (f) {
    writer.writeBool(
      210,
      f
    );
  }
  f = message.getEnableCloudUiPublicSafetyLightsV2();
  if (f) {
    writer.writeBool(
      212,
      f
    );
  }
  f = message.getEnableRfdHudCompass();
  if (f) {
    writer.writeBool(
      213,
      f
    );
  }
  f = message.getEnableFlyToPoiR47();
  if (f) {
    writer.writeBool(
      214,
      f
    );
  }
  f = message.getEnableRfdHudAirspeedAltitude();
  if (f) {
    writer.writeBool(
      216,
      f
    );
  }
  f = message.getEnableSiteWideWeatherSensorData();
  if (f) {
    writer.writeBool(
      217,
      f
    );
  }
  f = message.getEnableSiteWideAdsbData();
  if (f) {
    writer.writeBool(
      218,
      f
    );
  }
  f = message.getEnableIncidentMarkersRfd();
  if (f) {
    writer.writeBool(
      219,
      f
    );
  }
  f = message.getMoveVehicleLaunchModalVideoFeed();
  if (f) {
    writer.writeBool(
      220,
      f
    );
  }
  f = message.getEnableLookAtFinalPoint();
  if (f) {
    writer.writeBool(
      221,
      f
    );
  }
  f = message.getEnableDockTransitPoint();
  if (f) {
    writer.writeBool(
      222,
      f
    );
  }
  f = message.getEnableViewDownloadRtkPpkFiles();
  if (f) {
    writer.writeBool(
      224,
      f
    );
  }
  f = message.getPublicVisibilityDashboard();
  if (f) {
    writer.writeBool(
      225,
      f
    );
  }
  f = message.getUsePathfinderFlyToPointRfd();
  if (f) {
    writer.writeBool(
      227,
      f
    );
  }
  f = message.getMediaAvailableForFlightAlert();
  if (f) {
    writer.writeBool(
      228,
      f
    );
  }
  f = message.getEmitRtspStreamsToDefaultEgress();
  if (f) {
    writer.writeBool(
      230,
      f
    );
  }
  f = message.getDfrStockSettings();
  if (f) {
    writer.writeBool(
      232,
      f
    );
  }
  f = message.getCustomer2CustomMapboxMapStyles();
  if (f) {
    writer.writeBool(
      234,
      f
    );
  }
  f = message.getRfdConnectivitySettingsTab();
  if (f) {
    writer.writeBool(
      236,
      f
    );
  }
  f = message.getMissionEditorNightAutonomy();
  if (f) {
    writer.writeBool(
      237,
      f
    );
  }
  f = message.getRfdParachuteAttachmentUi();
  if (f) {
    writer.writeBool(
      238,
      f
    );
  }
  f = message.getShowCloudSimulatorControls();
  if (f) {
    writer.writeBool(
      239,
      f
    );
  }
  f = message.getMissionSharingCustomerPortal();
  if (f) {
    writer.writeBool(
      240,
      f
    );
  }
  f = message.getUseImprovedFlightStatusWorkflow();
  if (f) {
    writer.writeBool(
      243,
      f
    );
  }
  f = message.getEnableMarkersAr();
  if (f) {
    writer.writeBool(
      245,
      f
    );
  }
  f = message.getRfdTelemetryStats();
  if (f) {
    writer.writeBool(
      247,
      f
    );
  }
  f = message.getShowOperationsAreaInternalMapboxStyles();
  if (f) {
    writer.writeBool(
      248,
      f
    );
  }
  f = message.getActivateStrobeLightsOnLaunchRfd();
  if (f) {
    writer.writeBool(
      249,
      f
    );
  }
  f = message.getMissionDocumentsApi();
  if (f) {
    writer.writeBool(
      250,
      f
    );
  }
  f = message.getFleetPageSdCardFormatting();
  if (f) {
    writer.writeBool(
      251,
      f
    );
  }
  f = message.getEnableMultidroneOperations();
  if (f) {
    writer.writeBool(
      252,
      f
    );
  }
  f = message.getControlKeyDragWaypointVertical();
  if (f) {
    writer.writeBool(
      254,
      f
    );
  }
  f = message.getShowTerrainAndBldgsToggleInFleetPage();
  if (f) {
    writer.writeBool(
      255,
      f
    );
  }
  f = message.getManageFlyToPointHeightWithVehicleOverride();
  if (f) {
    writer.writeBool(
      256,
      f
    );
  }
  f = message.getAltKeyDragWaypointVertical();
  if (f) {
    writer.writeBool(
      257,
      f
    );
  }
  f = message.getCopyMarkersBetweenNypdOrgs();
  if (f) {
    writer.writeBool(
      258,
      f
    );
  }
  f = message.getShowOverlappingDockWifiChannelsFleetPage();
  if (f) {
    writer.writeBool(
      259,
      f
    );
  }
  f = message.getShowInternalMapboxStyles3();
  if (f) {
    writer.writeBool(
      261,
      f
    );
  }
  f = message.getFixedLocationRid();
  if (f) {
    writer.writeBool(
      262,
      f
    );
  }
  f = message.getAlertOnFlyToPointAltitudeChange();
  if (f) {
    writer.writeBool(
      263,
      f
    );
  }
  f = message.getTeleopPilotKeepAlive();
  if (f) {
    writer.writeBool(
      264,
      f
    );
  }
  f = message.getAscendSolarMapCaptureDemo();
  if (f) {
    writer.writeBool(
      270,
      f
    );
  }
  f = message.getUseWorldTakeoffFrameFlyToPoint();
  if (f) {
    writer.writeBool(
      271,
      f
    );
  }
  f = message.getEnableRtkSupport();
  if (f) {
    writer.writeBool(
      272,
      f
    );
  }
  f = message.getCityCustomerMapboxMapStyles();
  if (f) {
    writer.writeBool(
      274,
      f
    );
  }
  f = message.getLinkLossAlertLevelCaution();
  if (f) {
    writer.writeBool(
      276,
      f
    );
  }
  f = message.getEnableDownloadAllScanFiles();
  if (f) {
    writer.writeBool(
      277,
      f
    );
  }
  f = message.getShowAdsbStatusInRfd();
  if (f) {
    writer.writeBool(
      279,
      f
    );
  }
  f = message.getShowVioResetCloudOverride();
  if (f) {
    writer.writeBool(
      282,
      f
    );
  }
  f = message.getEnableStreamingRumEvents();
  if (f) {
    writer.writeBool(
      283,
      f
    );
  }
  f = message.getEnableStreamingDdLogs();
  if (f) {
    writer.writeBool(
      302,
      f
    );
  }
  f = message.getDisableStreamingMixpanelEvents();
  if (f) {
    writer.writeBool(
      421,
      f
    );
  }
  f = message.getDisplayMediaSyncSpeedTest();
  if (f) {
    writer.writeBool(
      287,
      f
    );
  }
  f = message.getEnableSetupFlights();
  if (f) {
    writer.writeBool(
      288,
      f
    );
  }
  f = message.getEuropeanUnion();
  if (f) {
    writer.writeBool(
      289,
      f
    );
  }
  f = message.getEnableEvShortcutsRfd();
  if (f) {
    writer.writeBool(
      290,
      f
    );
  }
  f = message.getEnableSettingsDevicesAccessPointUi();
  if (f) {
    writer.writeBool(
      291,
      f
    );
  }
  f = message.getEnableCreateMarkerInteractionRfd();
  if (f) {
    writer.writeBool(
      292,
      f
    );
  }
  f = message.getDronesenseIntegrationSetup();
  if (f) {
    writer.writeBool(
      293,
      f
    );
  }
  f = message.getSendParquetIngestorJobsToTemporal();
  if (f) {
    writer.writeBool(
      294,
      f
    );
  }
  f = message.getEnableC18MicrohardOfflineConfiguration();
  if (f) {
    writer.writeBool(
      295,
      f
    );
  }
  f = message.getCustomMapLayersExternal();
  if (f) {
    writer.writeBool(
      296,
      f
    );
  }
  f = message.getCustomMapLayersInternal();
  if (f) {
    writer.writeBool(
      297,
      f
    );
  }
  f = message.getDfrCommandPhase1MarkersUi();
  if (f) {
    writer.writeBool(
      298,
      f
    );
  }
  f = message.getEnableG47DockInspectionRfd();
  if (f) {
    writer.writeBool(
      299,
      f
    );
  }
  f = message.getDisableAutomaticVideoRecording();
  if (f) {
    writer.writeBool(
      301,
      f
    );
  }
  f = message.getFilterMarkersInRfdSidebar();
  if (f) {
    writer.writeBool(
      303,
      f
    );
  }
  f = message.getDfrCommand();
  if (f) {
    writer.writeBool(
      305,
      f
    );
  }
  f = message.getMissionDetailsAboveSkillsSwitcher();
  if (f) {
    writer.writeBool(
      306,
      f
    );
  }
  f = message.getMultiBatteryMissions();
  if (f) {
    writer.writeBool(
      307,
      f
    );
  }
  f = message.getSwapToX10DockCamOnLanding();
  if (f) {
    writer.writeBool(
      308,
      f
    );
  }
  f = message.getEnableRfdHudCompassV2();
  if (f) {
    writer.writeBool(
      309,
      f
    );
  }
  f = message.getEnableRfdDedrone();
  if (f) {
    writer.writeBool(
      310,
      f
    );
  }
  f = message.getEnableRfdAdsbRecording();
  if (f) {
    writer.writeBool(
      311,
      f
    );
  }
  f = message.getMissionEditorShowInternalNavigationModeOptions();
  if (f) {
    writer.writeBool(
      313,
      f
    );
  }
  f = message.getEnableDfrCommandPhaseTwoUi();
  if (f) {
    writer.writeBool(
      314,
      f
    );
  }
  f = message.getEnableDfrCommandPhaseTwoPointFiveUi();
  if (f) {
    writer.writeBool(
      315,
      f
    );
  }
  f = message.getEnableDfrCommandPhaseThreeUi();
  if (f) {
    writer.writeBool(
      316,
      f
    );
  }
  f = message.getEnableDfrOrgBasedLivekitRoom();
  if (f) {
    writer.writeBool(
      317,
      f
    );
  }
  f = message.getX10DefaultsForGpsInitWaypoint();
  if (f) {
    writer.writeBool(
      318,
      f
    );
  }
  f = message.getReadyLinkSecurityPin();
  if (f) {
    writer.writeBool(
      319,
      f
    );
  }
  f = message.getEnableDockDeviceSettingsPage();
  if (f) {
    writer.writeBool(
      320,
      f
    );
  }
  f = message.getEnableMediaSyncTabOnDeviceSettingsPage();
  if (f) {
    writer.writeBool(
      321,
      f
    );
  }
  f = message.getEnableProperArSync();
  if (f) {
    writer.writeBool(
      324,
      f
    );
  }
  f = message.getExternalApiIncidentMarkersUi();
  if (f) {
    writer.writeBool(
      325,
      f
    );
  }
  f = message.getMarkersAreaFilteringUi();
  if (f) {
    writer.writeBool(
      326,
      f
    );
  }
  f = message.getMarkersSidebarSortingUi();
  if (f) {
    writer.writeBool(
      327,
      f
    );
  }
  f = message.getEnableRfdViewLookatPoint();
  if (f) {
    writer.writeBool(
      329,
      f
    );
  }
  f = message.getEnableRfdSetLookatPoint();
  if (f) {
    writer.writeBool(
      330,
      f
    );
  }
  f = message.getEnableVehicleDeviceSettingsPage();
  if (f) {
    writer.writeBool(
      331,
      f
    );
  }
  f = message.getFleetFlightSystemHealth();
  if (f) {
    writer.writeBool(
      332,
      f
    );
  }
  f = message.getSimulateRemoteOnPremOrg();
  if (f) {
    writer.writeBool(
      333,
      f
    );
  }
  f = message.getEnableRfdAglAmsl();
  if (f) {
    writer.writeBool(
      335,
      f
    );
  }
  f = message.getReadyLinkSelectableStreams();
  if (f) {
    writer.writeBool(
      336,
      f
    );
  }
  f = message.getMultiOrgUsersRpic();
  if (f) {
    writer.writeBool(
      337,
      f
    );
  }
  f = message.getMarkersApi();
  if (f) {
    writer.writeBool(
      339,
      f
    );
  }
  f = message.getEnablePropsHoursHealth();
  if (f) {
    writer.writeBool(
      340,
      f
    );
  }
  f = message.getAllowDirectDeviceAdoption();
  if (f) {
    writer.writeBool(
      342,
      f
    );
  }
  f = message.getEnableDocklessSites();
  if (f) {
    writer.writeBool(
      343,
      f
    );
  }
  f = message.getEnableRampHeightModeFlyToPointRfd();
  if (f) {
    writer.writeBool(
      344,
      f
    );
  }
  f = message.getDeprecateOrgInvitations();
  if (f) {
    writer.writeBool(
      345,
      f
    );
  }
  f = message.getEnableReadyLink1Point3Ui();
  if (f) {
    writer.writeBool(
      346,
      f
    );
  }
  f = message.getEnableTeleopInIframe();
  if (f) {
    writer.writeBool(
      347,
      f
    );
  }
  f = message.getEnableDfrDockviewLayout();
  if (f) {
    writer.writeBool(
      348,
      f
    );
  }
  f = message.getEnableCustomerManagedSessionLengths();
  if (f) {
    writer.writeBool(
      349,
      f
    );
  }
  f = message.getEnableStandoffDistance();
  if (f) {
    writer.writeBool(
      350,
      f
    );
  }
  f = message.getSupportUserExpiry();
  if (f) {
    writer.writeBool(
      351,
      f
    );
  }
  f = message.getEnableDispatchRespondHere();
  if (f) {
    writer.writeBool(
      352,
      f
    );
  }
  f = message.getReadyLinkMultiVehicleSelect();
  if (f) {
    writer.writeBool(
      354,
      f
    );
  }
  f = message.getDeploymentEngineerMissionsInternal();
  if (f) {
    writer.writeBool(
      355,
      f
    );
  }
  f = message.getAddApiTokensToResourceGroups();
  if (f) {
    writer.writeBool(
      356,
      f
    );
  }
  f = message.getSetTakePhotoWaitForFocusToConverge();
  if (f) {
    writer.writeBool(
      357,
      f
    );
  }
  f = message.getCloudRel3UiUpdates();
  if (f) {
    writer.writeBool(
      358,
      f
    );
  }
  f = message.getEnableManualIncidentCreation();
  if (f) {
    writer.writeBool(
      359,
      f
    );
  }
  f = message.getEnableValidationOfOnDemandMission();
  if (f) {
    writer.writeBool(
      360,
      f
    );
  }
  f = message.getEnableAxonWatchMeDemo();
  if (f) {
    writer.writeBool(
      361,
      f
    );
  }
  f = message.getBatteryDevicePage();
  if (f) {
    writer.writeBool(
      362,
      f
    );
  }
  f = message.getEnableIncidentsStateUi();
  if (f) {
    writer.writeBool(
      363,
      f
    );
  }
  f = message.getEnablePlanningAroundGeofencesFlyToPointRfd();
  if (f) {
    writer.writeBool(
      364,
      f
    );
  }
  f = message.getBatteryFirmwareIncrement();
  if (f) {
    writer.writeBool(
      365,
      f
    );
  }
  f = message.getCloudRel4UiUpdates();
  if (f) {
    writer.writeBool(
      367,
      f
    );
  }
  f = message.getHiveChannelConflictPrevention();
  if (f) {
    writer.writeBool(
      368,
      f
    );
  }
  f = message.getSortDroneSelectionModalDispatch();
  if (f) {
    writer.writeBool(
      369,
      f
    );
  }
  f = message.getUnifiedMissionEditor();
  if (f) {
    writer.writeBool(
      370,
      f
    );
  }
  f = message.getMissionsCloudToController();
  if (f) {
    writer.writeBool(
      371,
      f
    );
  }
  f = message.getEnableWaypointMetricsWorkflow();
  if (f) {
    writer.writeBool(
      372,
      f
    );
  }
  f = message.getEnablePropellerTypeSpecification();
  if (f) {
    writer.writeBool(
      373,
      f
    );
  }
  f = message.getImprovedLandingButtons();
  if (f) {
    writer.writeBool(
      374,
      f
    );
  }
  f = message.getEnableAxonSha256();
  if (f) {
    writer.writeBool(
      375,
      f
    );
  }
  f = message.getEnableCancelIncidentResponseModal();
  if (f) {
    writer.writeBool(
      376,
      f
    );
  }
  f = message.getControllerDevicePage();
  if (f) {
    writer.writeBool(
      377,
      f
    );
  }
  f = message.getDisplayCellularCarrierInfo();
  if (f) {
    writer.writeBool(
      378,
      f
    );
  }
  f = message.getEnableUnsupportedBrowserWarning();
  if (f) {
    writer.writeBool(
      379,
      f
    );
  }
  f = message.getEnableExtraAccessModes();
  if (f) {
    writer.writeBool(
      380,
      f
    );
  }
  f = message.getEnableCustomMapLayersBackend();
  if (f) {
    writer.writeBool(
      381,
      f
    );
  }
  f = message.getEnablePriorityDfrCloudIa();
  if (f) {
    writer.writeBool(
      382,
      f
    );
  }
  f = message.getReverseGeocodeMarkersOnRead();
  if (f) {
    writer.writeBool(
      383,
      f
    );
  }
  f = message.getEditOrgFlightPolicyNondocked();
  if (f) {
    writer.writeBool(
      385,
      f
    );
  }
  f = message.getSitesImprovements525();
  if (f) {
    writer.writeBool(
      387,
      f
    );
  }
  f = message.getCloudRel5UiUpdates();
  if (f) {
    writer.writeBool(
      388,
      f
    );
  }
  f = message.getShowFileReleaseUi();
  if (f) {
    writer.writeBool(
      389,
      f
    );
  }
  f = message.getUseX10rev1AndUnknownAcceleratedPropWearAlert();
  if (f) {
    writer.writeBool(
      390,
      f
    );
  }
  f = message.getUseX10rev2AcceleratedPropWearAlert();
  if (f) {
    writer.writeBool(
      391,
      f
    );
  }
  f = message.getRtkEarlyAccessProgram();
  if (f) {
    writer.writeBool(
      392,
      f
    );
  }
  f = message.getNewCloudNavigation();
  if (f) {
    writer.writeBool(
      393,
      f
    );
  }
  f = message.getApiObservability();
  if (f) {
    writer.writeBool(
      394,
      f
    );
  }
  f = message.getNewIntegrationsUi();
  if (f) {
    writer.writeBool(
      395,
      f
    );
  }
  f = message.getShowSwIncompatibilityHealthIssue();
  if (f) {
    writer.writeBool(
      396,
      f
    );
  }
  f = message.getUpdatedCreateOrganizationModal();
  if (f) {
    writer.writeBool(
      397,
      f
    );
  }
  f = message.getCloudSimAutomaticSiteSetup();
  if (f) {
    writer.writeBool(
      398,
      f
    );
  }
  f = message.getReadyLinkViewerCountPoll();
  if (f) {
    writer.writeBool(
      399,
      f
    );
  }
  f = message.getSensorPackageDetailsEnabledUi();
  if (f) {
    writer.writeBool(
      401,
      f
    );
  }
  f = message.getEnablePostFlightReports();
  if (f) {
    writer.writeBool(
      402,
      f
    );
  }
  f = message.getArGoalAsStandoffIndicator();
  if (f) {
    writer.writeBool(
      404,
      f
    );
  }
  f = message.getShowAttachmentDetailsInCustomerPortal();
  if (f) {
    writer.writeBool(
      405,
      f
    );
  }
  f = message.getEnableDfrOutcomesSurvey();
  if (f) {
    writer.writeBool(
      406,
      f
    );
  }
  f = message.getRfdStreamlineNotifications();
  if (f) {
    writer.writeBool(
      407,
      f
    );
  }
  f = message.getFilterMarkerButtonInSidebar();
  if (f) {
    writer.writeBool(
      408,
      f
    );
  }
  f = message.getEnableBatteryFrettingAlerts();
  if (f) {
    writer.writeBool(
      409,
      f
    );
  }
  f = message.getEnableDistributionList();
  if (f) {
    writer.writeBool(
      410,
      f
    );
  }
  f = message.getIncludeCaseIdsInAxonEvidenceTitle();
  if (f) {
    writer.writeBool(
      411,
      f
    );
  }
  f = message.getShowInternalFlightDeckCommands();
  if (f) {
    writer.writeBool(
      412,
      f
    );
  }
  f = message.getShowDrawerSidebar();
  if (f) {
    writer.writeBool(
      413,
      f
    );
  }
  f = message.getTurboReduxBridge();
  if (f) {
    writer.writeBool(
      414,
      f
    );
  }
  f = message.getUseNewFlashpackChannels();
  if (f) {
    writer.writeBool(
      415,
      f
    );
  }
  f = message.getDisableEmailLogins();
  if (f) {
    writer.writeBool(
      416,
      f
    );
  }
  f = message.getEnableFususCadPoller();
  if (f) {
    writer.writeBool(
      417,
      f
    );
  }
  f = message.getCloudRel6UiUpdates();
  if (f) {
    writer.writeBool(
      418,
      f
    );
  }
  f = message.getCloudRel7UiUpdates();
  if (f) {
    writer.writeBool(
      419,
      f
    );
  }
  f = message.getMultipleMediaSyncPolicies();
  if (f) {
    writer.writeBool(
      420,
      f
    );
  }
  f = message.getShowA22DetailsInUi();
  if (f) {
    writer.writeBool(
      422,
      f
    );
  }
  f = message.getOtherDevicePage();
  if (f) {
    writer.writeBool(
      423,
      f
    );
  }
  f = message.getSubjectTracking();
  if (f) {
    writer.writeBool(
      424,
      f
    );
  }
  f = message.getAssetInspectionMissionPlanningV0();
  if (f) {
    writer.writeBool(
      425,
      f
    );
  }
  f = message.getEnablePreFlightChecklists();
  if (f) {
    writer.writeBool(
      426,
      f
    );
  }
  f = message.getBrandingDfrCommand();
  if (f) {
    writer.writeBool(
      427,
      f
    );
  }
  f = message.getShowCellularConfigs();
  if (f) {
    writer.writeBool(
      428,
      f
    );
  }
  f = message.getEnableSurfaceScanSkillTeleop();
  if (f) {
    writer.writeBool(
      429,
      f
    );
  }
  f = message.getAutonomyWidgetRfd();
  if (f) {
    writer.writeBool(
      430,
      f
    );
  }
  f = message.getShowPropellerHoursTrackingOverrideSetting();
  if (f) {
    writer.writeBool(
      431,
      f
    );
  }
  f = message.getDockComputeReplacement();
  if (f) {
    writer.writeBool(
      432,
      f
    );
  }
  f = message.getEnableCreateStubFlightWorkflow();
  if (f) {
    writer.writeBool(
      433,
      f
    );
  }
  f = message.getAxonGlobalRegion();
  if (f) {
    writer.writeBool(
      434,
      f
    );
  }
  f = message.getAllowScanPlaneOffsetForMapCapture();
  if (f) {
    writer.writeBool(
      435,
      f
    );
  }
  f = message.getRtkPpkRfdTelemetry();
  if (f) {
    writer.writeBool(
      436,
      f
    );
  }
  f = message.getSubjectTrackingForEngineering();
  if (f) {
    writer.writeBool(
      437,
      f
    );
  }
  f = message.getPrepared911Integration();
  if (f) {
    writer.writeBool(
      438,
      f
    );
  }
  f = message.getEnableMultidroneAscendFy26();
  if (f) {
    writer.writeBool(
      440,
      f
    );
  }
};


/**
 * optional bool vehicle_teleoperation = 3;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getVehicleTeleoperation = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setVehicleTeleoperation = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool automatic_file_upload_page = 4;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAutomaticFileUploadPage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAutomaticFileUploadPage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool vehicle_licenses_page = 5;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getVehicleLicensesPage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setVehicleLicensesPage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool live_streaming = 6;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getLiveStreaming = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setLiveStreaming = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool axon_media_integration = 7;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAxonMediaIntegration = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAxonMediaIntegration = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool missions_page = 8;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMissionsPage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMissionsPage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional bool vehicle_remote_streaming = 9;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getVehicleRemoteStreaming = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setVehicleRemoteStreaming = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional bool mobile_remote_streaming = 10;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMobileRemoteStreaming = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMobileRemoteStreaming = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool multi_viewer_streaming = 12;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMultiViewerStreaming = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMultiViewerStreaming = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional bool axon_respond_integration = 13;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAxonRespondIntegration = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAxonRespondIntegration = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional bool view_offline_settings = 14;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getViewOfflineSettings = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setViewOfflineSettings = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional bool configure_obstacle_margin = 15;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getConfigureObstacleMargin = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setConfigureObstacleMargin = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional bool dro_internal = 16;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDroInternal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDroInternal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};


/**
 * optional bool annotations = 21;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAnnotations = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 21, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAnnotations = function(value) {
  return jspb.Message.setProto3BooleanField(this, 21, value);
};


/**
 * optional bool cloud_inspect_page = 22;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCloudInspectPage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 22, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCloudInspectPage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 22, value);
};


/**
 * optional bool mission_media_viewer = 23;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMissionMediaViewer = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 23, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMissionMediaViewer = function(value) {
  return jspb.Message.setProto3BooleanField(this, 23, value);
};


/**
 * optional bool automatic_cloud_photogrammetry = 26;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAutomaticCloudPhotogrammetry = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 26, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAutomaticCloudPhotogrammetry = function(value) {
  return jspb.Message.setProto3BooleanField(this, 26, value);
};


/**
 * optional bool dock_location_update = 27;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDockLocationUpdate = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 27, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDockLocationUpdate = function(value) {
  return jspb.Message.setProto3BooleanField(this, 27, value);
};


/**
 * optional bool disable_teleop_landing_prompt = 29;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDisableTeleopLandingPrompt = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 29, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDisableTeleopLandingPrompt = function(value) {
  return jspb.Message.setProto3BooleanField(this, 29, value);
};


/**
 * optional bool dro_teleop_run_mission_json = 31;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDroTeleopRunMissionJson = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 31, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDroTeleopRunMissionJson = function(value) {
  return jspb.Message.setProto3BooleanField(this, 31, value);
};


/**
 * optional bool hide_land_now_during_rtd = 33;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getHideLandNowDuringRtd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 33, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setHideLandNowDuringRtd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 33, value);
};


/**
 * optional bool remote_video_api_access = 36;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRemoteVideoApiAccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 36, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRemoteVideoApiAccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 36, value);
};


/**
 * optional bool allow_twilight_flight = 38;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAllowTwilightFlight = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 38, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAllowTwilightFlight = function(value) {
  return jspb.Message.setProto3BooleanField(this, 38, value);
};


/**
 * optional bool allow_backtracking_rtx = 39;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAllowBacktrackingRtx = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 39, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAllowBacktrackingRtx = function(value) {
  return jspb.Message.setProto3BooleanField(this, 39, value);
};


/**
 * optional bool cloud_ota = 40;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCloudOta = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 40, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCloudOta = function(value) {
  return jspb.Message.setProto3BooleanField(this, 40, value);
};


/**
 * optional bool teleop_debug_menu = 41;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTeleopDebugMenu = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 41, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTeleopDebugMenu = function(value) {
  return jspb.Message.setProto3BooleanField(this, 41, value);
};


/**
 * optional bool qos_skybus_channel_setting = 42;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getQosSkybusChannelSetting = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 42, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setQosSkybusChannelSetting = function(value) {
  return jspb.Message.setProto3BooleanField(this, 42, value);
};


/**
 * optional bool post_refactor_mission_editor = 43;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getPostRefactorMissionEditor = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 43, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setPostRefactorMissionEditor = function(value) {
  return jspb.Message.setProto3BooleanField(this, 43, value);
};


/**
 * optional bool network_debugging_tools = 46;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getNetworkDebuggingTools = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 46, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setNetworkDebuggingTools = function(value) {
  return jspb.Message.setProto3BooleanField(this, 46, value);
};


/**
 * optional bool full_height_video_enabled = 47;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getFullHeightVideoEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 47, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setFullHeightVideoEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 47, value);
};


/**
 * optional bool nav_height_above_ground_enabled = 49;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getNavHeightAboveGroundEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 49, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setNavHeightAboveGroundEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 49, value);
};


/**
 * optional bool internal_theme_toggle = 51;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getInternalThemeToggle = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 51, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setInternalThemeToggle = function(value) {
  return jspb.Message.setProto3BooleanField(this, 51, value);
};


/**
 * optional bool customer_custom_mapbox_map_styles = 53;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCustomerCustomMapboxMapStyles = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 53, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCustomerCustomMapboxMapStyles = function(value) {
  return jspb.Message.setProto3BooleanField(this, 53, value);
};


/**
 * optional bool show_vehicle_faults_teleop = 63;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowVehicleFaultsTeleop = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 63, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowVehicleFaultsTeleop = function(value) {
  return jspb.Message.setProto3BooleanField(this, 63, value);
};


/**
 * optional bool show_vps_info = 66;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowVpsInfo = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 66, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowVpsInfo = function(value) {
  return jspb.Message.setProto3BooleanField(this, 66, value);
};


/**
 * optional bool teleop_ar_v2 = 67;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTeleopArV2 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 67, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTeleopArV2 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 67, value);
};


/**
 * optional bool mission_control_api = 68;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMissionControlApi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 68, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMissionControlApi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 68, value);
};


/**
 * optional bool schedule_mission_now_api = 69;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getScheduleMissionNowApi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 69, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setScheduleMissionNowApi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 69, value);
};


/**
 * optional bool surface_scan_missions = 71;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSurfaceScanMissions = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 71, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSurfaceScanMissions = function(value) {
  return jspb.Message.setProto3BooleanField(this, 71, value);
};


/**
 * optional bool show_april_tag_settings = 72;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowAprilTagSettings = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 72, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowAprilTagSettings = function(value) {
  return jspb.Message.setProto3BooleanField(this, 72, value);
};


/**
 * optional bool show_skydio_link_settings = 73;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowSkydioLinkSettings = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 73, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowSkydioLinkSettings = function(value) {
  return jspb.Message.setProto3BooleanField(this, 73, value);
};


/**
 * optional bool whats_new = 76;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getWhatsNew = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 76, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setWhatsNew = function(value) {
  return jspb.Message.setProto3BooleanField(this, 76, value);
};


/**
 * optional bool show_range_limit_settings = 80;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowRangeLimitSettings = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 80, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowRangeLimitSettings = function(value) {
  return jspb.Message.setProto3BooleanField(this, 80, value);
};


/**
 * optional bool site_mapper = 85;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSiteMapper = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 85, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSiteMapper = function(value) {
  return jspb.Message.setProto3BooleanField(this, 85, value);
};


/**
 * optional bool show_band_selection_settings = 86;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowBandSelectionSettings = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 86, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowBandSelectionSettings = function(value) {
  return jspb.Message.setProto3BooleanField(this, 86, value);
};


/**
 * optional bool fly_now_no_automatic_run_mode_switching = 87;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getFlyNowNoAutomaticRunModeSwitching = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 87, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setFlyNowNoAutomaticRunModeSwitching = function(value) {
  return jspb.Message.setProto3BooleanField(this, 87, value);
};


/**
 * optional bool ar_video_sync = 88;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getArVideoSync = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 88, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setArVideoSync = function(value) {
  return jspb.Message.setProto3BooleanField(this, 88, value);
};


/**
 * optional bool mission_results_3d_viewer = 89;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMissionResults3dViewer = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 89, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMissionResults3dViewer = function(value) {
  return jspb.Message.setProto3BooleanField(this, 89, value);
};


/**
 * optional bool automatic_ncpg_photogrammetry = 92;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAutomaticNcpgPhotogrammetry = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 92, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAutomaticNcpgPhotogrammetry = function(value) {
  return jspb.Message.setProto3BooleanField(this, 92, value);
};


/**
 * optional bool executive_action_hotkeys = 93;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getExecutiveActionHotkeys = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 93, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setExecutiveActionHotkeys = function(value) {
  return jspb.Message.setProto3BooleanField(this, 93, value);
};


/**
 * optional bool vehicle_type_based_axon_sessions = 94;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getVehicleTypeBasedAxonSessions = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 94, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setVehicleTypeBasedAxonSessions = function(value) {
  return jspb.Message.setProto3BooleanField(this, 94, value);
};


/**
 * optional bool site_missions = 98;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSiteMissions = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 98, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSiteMissions = function(value) {
  return jspb.Message.setProto3BooleanField(this, 98, value);
};


/**
 * optional bool always_show_camera_settings = 99;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAlwaysShowCameraSettings = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 99, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAlwaysShowCameraSettings = function(value) {
  return jspb.Message.setProto3BooleanField(this, 99, value);
};


/**
 * optional bool teleop_waypoint_commands = 101;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTeleopWaypointCommands = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 101, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTeleopWaypointCommands = function(value) {
  return jspb.Message.setProto3BooleanField(this, 101, value);
};


/**
 * optional bool dro_remote_id = 105;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDroRemoteId = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 105, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDroRemoteId = function(value) {
  return jspb.Message.setProto3BooleanField(this, 105, value);
};


/**
 * optional bool prop_guards_enablement = 108;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getPropGuardsEnablement = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 108, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setPropGuardsEnablement = function(value) {
  return jspb.Message.setProto3BooleanField(this, 108, value);
};


/**
 * optional bool remote_pilot_api_access = 111;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRemotePilotApiAccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 111, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRemotePilotApiAccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 111, value);
};


/**
 * optional bool show_view_flight_deck_button = 112;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowViewFlightDeckButton = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 112, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowViewFlightDeckButton = function(value) {
  return jspb.Message.setProto3BooleanField(this, 112, value);
};


/**
 * optional bool twilight_mode_fast_flight = 113;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTwilightModeFastFlight = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 113, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTwilightModeFastFlight = function(value) {
  return jspb.Message.setProto3BooleanField(this, 113, value);
};


/**
 * optional bool standalone_map_page = 114;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getStandaloneMapPage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 114, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setStandaloneMapPage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 114, value);
};


/**
 * optional bool mission_resume = 115;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMissionResume = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 115, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMissionResume = function(value) {
  return jspb.Message.setProto3BooleanField(this, 115, value);
};


/**
 * optional bool lost_comms_timeout_setting_teleop = 116;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getLostCommsTimeoutSettingTeleop = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 116, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setLostCommsTimeoutSettingTeleop = function(value) {
  return jspb.Message.setProto3BooleanField(this, 116, value);
};


/**
 * optional bool teleop_fast_flight = 117;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTeleopFastFlight = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 117, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTeleopFastFlight = function(value) {
  return jspb.Message.setProto3BooleanField(this, 117, value);
};


/**
 * optional bool allow_edit_adsb_settings = 119;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAllowEditAdsbSettings = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 119, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAllowEditAdsbSettings = function(value) {
  return jspb.Message.setProto3BooleanField(this, 119, value);
};


/**
 * optional bool show_teleop_idle_modal = 121;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowTeleopIdleModal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 121, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowTeleopIdleModal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 121, value);
};


/**
 * optional bool skydio_extend = 122;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSkydioExtend = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 122, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSkydioExtend = function(value) {
  return jspb.Message.setProto3BooleanField(this, 122, value);
};


/**
 * optional bool support_menu_v2 = 123;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSupportMenuV2 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 123, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSupportMenuV2 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 123, value);
};


/**
 * optional bool geofence_enforcement_in_cloud = 125;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getGeofenceEnforcementInCloud = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 125, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setGeofenceEnforcementInCloud = function(value) {
  return jspb.Message.setProto3BooleanField(this, 125, value);
};


/**
 * optional bool sensor_data_view_claim = 126;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSensorDataViewClaim = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 126, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSensorDataViewClaim = function(value) {
  return jspb.Message.setProto3BooleanField(this, 126, value);
};


/**
 * optional bool teleop_third_person_view = 129;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTeleopThirdPersonView = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 129, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTeleopThirdPersonView = function(value) {
  return jspb.Message.setProto3BooleanField(this, 129, value);
};


/**
 * optional bool show_teleop_circular_battery_widget = 132;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowTeleopCircularBatteryWidget = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 132, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowTeleopCircularBatteryWidget = function(value) {
  return jspb.Message.setProto3BooleanField(this, 132, value);
};


/**
 * optional bool alert_manager_with_audio_in_teleop = 133;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAlertManagerWithAudioInTeleop = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 133, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAlertManagerWithAudioInTeleop = function(value) {
  return jspb.Message.setProto3BooleanField(this, 133, value);
};


/**
 * optional bool structure_annotations_api = 134;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getStructureAnnotationsApi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 134, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setStructureAnnotationsApi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 134, value);
};


/**
 * optional bool move_livestream_tag_position = 135;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMoveLivestreamTagPosition = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 135, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMoveLivestreamTagPosition = function(value) {
  return jspb.Message.setProto3BooleanField(this, 135, value);
};


/**
 * optional bool show_active_pilot_name_if_livestreaming = 136;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowActivePilotNameIfLivestreaming = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 136, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowActivePilotNameIfLivestreaming = function(value) {
  return jspb.Message.setProto3BooleanField(this, 136, value);
};


/**
 * optional bool move_share_livestream_button_to_icon = 137;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMoveShareLivestreamButtonToIcon = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 137, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMoveShareLivestreamButtonToIcon = function(value) {
  return jspb.Message.setProto3BooleanField(this, 137, value);
};


/**
 * optional bool own_org_groups = 138;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getOwnOrgGroups = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 138, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setOwnOrgGroups = function(value) {
  return jspb.Message.setProto3BooleanField(this, 138, value);
};


/**
 * optional bool teleop_commandeering_v2 = 139;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTeleopCommandeeringV2 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 139, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTeleopCommandeeringV2 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 139, value);
};


/**
 * optional bool media_available_alert = 140;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMediaAvailableAlert = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 140, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMediaAvailableAlert = function(value) {
  return jspb.Message.setProto3BooleanField(this, 140, value);
};


/**
 * optional bool media_available_for_scan_alert = 141;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMediaAvailableForScanAlert = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 141, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMediaAvailableForScanAlert = function(value) {
  return jspb.Message.setProto3BooleanField(this, 141, value);
};


/**
 * optional bool ncpg_photogrammetry_use_tensor_rt_flow_model = 142;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getNcpgPhotogrammetryUseTensorRtFlowModel = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 142, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setNcpgPhotogrammetryUseTensorRtFlowModel = function(value) {
  return jspb.Message.setProto3BooleanField(this, 142, value);
};


/**
 * optional bool show_faa_mapbox_styles = 143;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowFaaMapboxStyles = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 143, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowFaaMapboxStyles = function(value) {
  return jspb.Message.setProto3BooleanField(this, 143, value);
};


/**
 * optional bool allow_scheduling_r47_missions = 144;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAllowSchedulingR47Missions = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 144, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAllowSchedulingR47Missions = function(value) {
  return jspb.Message.setProto3BooleanField(this, 144, value);
};


/**
 * optional bool sites_structure_editor = 147;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSitesStructureEditor = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 147, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSitesStructureEditor = function(value) {
  return jspb.Message.setProto3BooleanField(this, 147, value);
};


/**
 * optional bool multi_mission_flight_tester = 148;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMultiMissionFlightTester = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 148, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMultiMissionFlightTester = function(value) {
  return jspb.Message.setProto3BooleanField(this, 148, value);
};


/**
 * optional bool teleop_settings_modal_v3 = 153;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTeleopSettingsModalV3 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 153, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTeleopSettingsModalV3 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 153, value);
};


/**
 * optional bool x10_eo_camera_controls_parity_in_teleop = 154;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getX10EoCameraControlsParityInTeleop = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 154, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setX10EoCameraControlsParityInTeleop = function(value) {
  return jspb.Message.setProto3BooleanField(this, 154, value);
};


/**
 * optional bool no_obstacle_avoidance_in_teleop = 155;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getNoObstacleAvoidanceInTeleop = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 155, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setNoObstacleAvoidanceInTeleop = function(value) {
  return jspb.Message.setProto3BooleanField(this, 155, value);
};


/**
 * optional bool live_mission_planning = 158;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getLiveMissionPlanning = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 158, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setLiveMissionPlanning = function(value) {
  return jspb.Message.setProto3BooleanField(this, 158, value);
};


/**
 * optional bool waypoint_camera_settings = 161;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getWaypointCameraSettings = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 161, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setWaypointCameraSettings = function(value) {
  return jspb.Message.setProto3BooleanField(this, 161, value);
};


/**
 * optional bool vps_map_datamodel_transition_read_from_new = 162;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getVpsMapDatamodelTransitionReadFromNew = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 162, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setVpsMapDatamodelTransitionReadFromNew = function(value) {
  return jspb.Message.setProto3BooleanField(this, 162, value);
};


/**
 * optional bool vps_map_datamodel_transition_write_to_both = 163;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getVpsMapDatamodelTransitionWriteToBoth = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 163, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setVpsMapDatamodelTransitionWriteToBoth = function(value) {
  return jspb.Message.setProto3BooleanField(this, 163, value);
};


/**
 * optional bool edit_org_flight_policy = 164;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEditOrgFlightPolicy = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 164, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEditOrgFlightPolicy = function(value) {
  return jspb.Message.setProto3BooleanField(this, 164, value);
};


/**
 * optional bool teleop_wheel_zoom = 165;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTeleopWheelZoom = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 165, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTeleopWheelZoom = function(value) {
  return jspb.Message.setProto3BooleanField(this, 165, value);
};


/**
 * optional bool multizone_site_geofences = 166;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMultizoneSiteGeofences = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 166, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMultizoneSiteGeofences = function(value) {
  return jspb.Message.setProto3BooleanField(this, 166, value);
};


/**
 * optional bool teleop_bitrate_slider = 168;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTeleopBitrateSlider = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 168, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTeleopBitrateSlider = function(value) {
  return jspb.Message.setProto3BooleanField(this, 168, value);
};


/**
 * optional bool x10_zoom_and_flash_ui = 169;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getX10ZoomAndFlashUi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 169, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setX10ZoomAndFlashUi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 169, value);
};


/**
 * optional bool rid_feature_disabled = 171;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRidFeatureDisabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 171, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRidFeatureDisabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 171, value);
};


/**
 * optional bool remove_flight_from_resource_group = 173;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRemoveFlightFromResourceGroup = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 173, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRemoveFlightFromResourceGroup = function(value) {
  return jspb.Message.setProto3BooleanField(this, 173, value);
};


/**
 * optional bool safe_landing_points = 174;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSafeLandingPoints = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 174, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSafeLandingPoints = function(value) {
  return jspb.Message.setProto3BooleanField(this, 174, value);
};


/**
 * optional bool teleop_boost_mode = 177;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTeleopBoostMode = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 177, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTeleopBoostMode = function(value) {
  return jspb.Message.setProto3BooleanField(this, 177, value);
};


/**
 * optional bool teleop_crawl_mode = 178;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTeleopCrawlMode = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 178, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTeleopCrawlMode = function(value) {
  return jspb.Message.setProto3BooleanField(this, 178, value);
};


/**
 * optional bool enable_fly_to_poi_rfd = 179;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableFlyToPoiRfd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 179, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableFlyToPoiRfd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 179, value);
};


/**
 * optional bool show_operations_area_mapbox_styles = 180;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowOperationsAreaMapboxStyles = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 180, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowOperationsAreaMapboxStyles = function(value) {
  return jspb.Message.setProto3BooleanField(this, 180, value);
};


/**
 * optional bool barometer_height_mode = 183;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getBarometerHeightMode = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 183, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setBarometerHeightMode = function(value) {
  return jspb.Message.setProto3BooleanField(this, 183, value);
};


/**
 * optional bool graphiql_viewer = 186;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getGraphiqlViewer = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 186, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setGraphiqlViewer = function(value) {
  return jspb.Message.setProto3BooleanField(this, 186, value);
};


/**
 * optional bool enable_orbit_to_poi_rfd = 187;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableOrbitToPoiRfd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 187, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableOrbitToPoiRfd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 187, value);
};


/**
 * optional bool disable_cloud_config_signature_verification = 188;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDisableCloudConfigSignatureVerification = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 188, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDisableCloudConfigSignatureVerification = function(value) {
  return jspb.Message.setProto3BooleanField(this, 188, value);
};


/**
 * optional bool is_onprem_org = 189;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getIsOnpremOrg = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 189, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setIsOnpremOrg = function(value) {
  return jspb.Message.setProto3BooleanField(this, 189, value);
};


/**
 * optional bool enable_pointer_lock_during_missions_rfd = 190;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnablePointerLockDuringMissionsRfd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 190, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnablePointerLockDuringMissionsRfd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 190, value);
};


/**
 * optional bool enable_map_vehicle_followiing = 192;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableMapVehicleFollowiing = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 192, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableMapVehicleFollowiing = function(value) {
  return jspb.Message.setProto3BooleanField(this, 192, value);
};


/**
 * optional bool ready_link_single_vehicle = 193;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getReadyLinkSingleVehicle = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 193, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setReadyLinkSingleVehicle = function(value) {
  return jspb.Message.setProto3BooleanField(this, 193, value);
};


/**
 * optional bool teleop_telemetry_heading_and_gimbal_pitch = 194;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTeleopTelemetryHeadingAndGimbalPitch = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 194, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTeleopTelemetryHeadingAndGimbalPitch = function(value) {
  return jspb.Message.setProto3BooleanField(this, 194, value);
};


/**
 * optional bool media_page_kind_dropdown = 195;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMediaPageKindDropdown = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 195, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMediaPageKindDropdown = function(value) {
  return jspb.Message.setProto3BooleanField(this, 195, value);
};


/**
 * optional bool teleop_actions_toolbar = 196;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTeleopActionsToolbar = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 196, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTeleopActionsToolbar = function(value) {
  return jspb.Message.setProto3BooleanField(this, 196, value);
};


/**
 * optional bool enable_dock_landing_ar = 199;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableDockLandingAr = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 199, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableDockLandingAr = function(value) {
  return jspb.Message.setProto3BooleanField(this, 199, value);
};


/**
 * optional bool teleop_nav_source_info_health = 201;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTeleopNavSourceInfoHealth = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 201, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTeleopNavSourceInfoHealth = function(value) {
  return jspb.Message.setProto3BooleanField(this, 201, value);
};


/**
 * optional bool enable_axon_markers_rfd = 202;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableAxonMarkersRfd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 202, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableAxonMarkersRfd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 202, value);
};


/**
 * optional bool enable_fpv_on_map = 203;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableFpvOnMap = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 203, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableFpvOnMap = function(value) {
  return jspb.Message.setProto3BooleanField(this, 203, value);
};


/**
 * optional bool offline_updates_page = 204;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getOfflineUpdatesPage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 204, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setOfflineUpdatesPage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 204, value);
};


/**
 * optional bool gimbal_pitch_reset_shortcut = 206;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getGimbalPitchResetShortcut = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 206, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setGimbalPitchResetShortcut = function(value) {
  return jspb.Message.setProto3BooleanField(this, 206, value);
};


/**
 * optional bool r47_show_mission_planners = 208;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getR47ShowMissionPlanners = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 208, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setR47ShowMissionPlanners = function(value) {
  return jspb.Message.setProto3BooleanField(this, 208, value);
};


/**
 * optional bool rfd_controller_max_speed_parity = 209;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRfdControllerMaxSpeedParity = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 209, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRfdControllerMaxSpeedParity = function(value) {
  return jspb.Message.setProto3BooleanField(this, 209, value);
};


/**
 * optional bool enable_ar_street_overlays = 210;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableArStreetOverlays = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 210, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableArStreetOverlays = function(value) {
  return jspb.Message.setProto3BooleanField(this, 210, value);
};


/**
 * optional bool enable_cloud_ui_public_safety_lights_v2 = 212;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableCloudUiPublicSafetyLightsV2 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 212, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableCloudUiPublicSafetyLightsV2 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 212, value);
};


/**
 * optional bool enable_rfd_hud_compass = 213;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableRfdHudCompass = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 213, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableRfdHudCompass = function(value) {
  return jspb.Message.setProto3BooleanField(this, 213, value);
};


/**
 * optional bool enable_fly_to_poi_r47 = 214;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableFlyToPoiR47 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 214, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableFlyToPoiR47 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 214, value);
};


/**
 * optional bool enable_rfd_hud_airspeed_altitude = 216;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableRfdHudAirspeedAltitude = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 216, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableRfdHudAirspeedAltitude = function(value) {
  return jspb.Message.setProto3BooleanField(this, 216, value);
};


/**
 * optional bool enable_site_wide_weather_sensor_data = 217;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableSiteWideWeatherSensorData = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 217, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableSiteWideWeatherSensorData = function(value) {
  return jspb.Message.setProto3BooleanField(this, 217, value);
};


/**
 * optional bool enable_site_wide_adsb_data = 218;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableSiteWideAdsbData = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 218, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableSiteWideAdsbData = function(value) {
  return jspb.Message.setProto3BooleanField(this, 218, value);
};


/**
 * optional bool enable_incident_markers_rfd = 219;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableIncidentMarkersRfd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 219, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableIncidentMarkersRfd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 219, value);
};


/**
 * optional bool move_vehicle_launch_modal_video_feed = 220;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMoveVehicleLaunchModalVideoFeed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 220, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMoveVehicleLaunchModalVideoFeed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 220, value);
};


/**
 * optional bool enable_look_at_final_point = 221;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableLookAtFinalPoint = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 221, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableLookAtFinalPoint = function(value) {
  return jspb.Message.setProto3BooleanField(this, 221, value);
};


/**
 * optional bool enable_dock_transit_point = 222;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableDockTransitPoint = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 222, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableDockTransitPoint = function(value) {
  return jspb.Message.setProto3BooleanField(this, 222, value);
};


/**
 * optional bool enable_view_download_rtk_ppk_files = 224;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableViewDownloadRtkPpkFiles = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 224, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableViewDownloadRtkPpkFiles = function(value) {
  return jspb.Message.setProto3BooleanField(this, 224, value);
};


/**
 * optional bool public_visibility_dashboard = 225;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getPublicVisibilityDashboard = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 225, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setPublicVisibilityDashboard = function(value) {
  return jspb.Message.setProto3BooleanField(this, 225, value);
};


/**
 * optional bool use_pathfinder_fly_to_point_rfd = 227;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getUsePathfinderFlyToPointRfd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 227, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setUsePathfinderFlyToPointRfd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 227, value);
};


/**
 * optional bool media_available_for_flight_alert = 228;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMediaAvailableForFlightAlert = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 228, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMediaAvailableForFlightAlert = function(value) {
  return jspb.Message.setProto3BooleanField(this, 228, value);
};


/**
 * optional bool emit_rtsp_streams_to_default_egress = 230;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEmitRtspStreamsToDefaultEgress = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 230, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEmitRtspStreamsToDefaultEgress = function(value) {
  return jspb.Message.setProto3BooleanField(this, 230, value);
};


/**
 * optional bool dfr_stock_settings = 232;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDfrStockSettings = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 232, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDfrStockSettings = function(value) {
  return jspb.Message.setProto3BooleanField(this, 232, value);
};


/**
 * optional bool customer_2_custom_mapbox_map_styles = 234;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCustomer2CustomMapboxMapStyles = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 234, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCustomer2CustomMapboxMapStyles = function(value) {
  return jspb.Message.setProto3BooleanField(this, 234, value);
};


/**
 * optional bool rfd_connectivity_settings_tab = 236;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRfdConnectivitySettingsTab = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 236, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRfdConnectivitySettingsTab = function(value) {
  return jspb.Message.setProto3BooleanField(this, 236, value);
};


/**
 * optional bool mission_editor_night_autonomy = 237;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMissionEditorNightAutonomy = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 237, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMissionEditorNightAutonomy = function(value) {
  return jspb.Message.setProto3BooleanField(this, 237, value);
};


/**
 * optional bool rfd_parachute_attachment_ui = 238;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRfdParachuteAttachmentUi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 238, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRfdParachuteAttachmentUi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 238, value);
};


/**
 * optional bool show_cloud_simulator_controls = 239;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowCloudSimulatorControls = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 239, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowCloudSimulatorControls = function(value) {
  return jspb.Message.setProto3BooleanField(this, 239, value);
};


/**
 * optional bool mission_sharing_customer_portal = 240;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMissionSharingCustomerPortal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 240, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMissionSharingCustomerPortal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 240, value);
};


/**
 * optional bool use_improved_flight_status_workflow = 243;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getUseImprovedFlightStatusWorkflow = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 243, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setUseImprovedFlightStatusWorkflow = function(value) {
  return jspb.Message.setProto3BooleanField(this, 243, value);
};


/**
 * optional bool enable_markers_ar = 245;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableMarkersAr = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 245, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableMarkersAr = function(value) {
  return jspb.Message.setProto3BooleanField(this, 245, value);
};


/**
 * optional bool rfd_telemetry_stats = 247;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRfdTelemetryStats = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 247, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRfdTelemetryStats = function(value) {
  return jspb.Message.setProto3BooleanField(this, 247, value);
};


/**
 * optional bool show_operations_area_internal_mapbox_styles = 248;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowOperationsAreaInternalMapboxStyles = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 248, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowOperationsAreaInternalMapboxStyles = function(value) {
  return jspb.Message.setProto3BooleanField(this, 248, value);
};


/**
 * optional bool activate_strobe_lights_on_launch_rfd = 249;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getActivateStrobeLightsOnLaunchRfd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 249, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setActivateStrobeLightsOnLaunchRfd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 249, value);
};


/**
 * optional bool mission_documents_api = 250;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMissionDocumentsApi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 250, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMissionDocumentsApi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 250, value);
};


/**
 * optional bool fleet_page_sd_card_formatting = 251;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getFleetPageSdCardFormatting = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 251, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setFleetPageSdCardFormatting = function(value) {
  return jspb.Message.setProto3BooleanField(this, 251, value);
};


/**
 * optional bool enable_multidrone_operations = 252;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableMultidroneOperations = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 252, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableMultidroneOperations = function(value) {
  return jspb.Message.setProto3BooleanField(this, 252, value);
};


/**
 * optional bool control_key_drag_waypoint_vertical = 254;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getControlKeyDragWaypointVertical = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 254, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setControlKeyDragWaypointVertical = function(value) {
  return jspb.Message.setProto3BooleanField(this, 254, value);
};


/**
 * optional bool show_terrain_and_bldgs_toggle_in_fleet_page = 255;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowTerrainAndBldgsToggleInFleetPage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 255, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowTerrainAndBldgsToggleInFleetPage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 255, value);
};


/**
 * optional bool manage_fly_to_point_height_with_vehicle_override = 256;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getManageFlyToPointHeightWithVehicleOverride = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 256, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setManageFlyToPointHeightWithVehicleOverride = function(value) {
  return jspb.Message.setProto3BooleanField(this, 256, value);
};


/**
 * optional bool alt_key_drag_waypoint_vertical = 257;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAltKeyDragWaypointVertical = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 257, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAltKeyDragWaypointVertical = function(value) {
  return jspb.Message.setProto3BooleanField(this, 257, value);
};


/**
 * optional bool copy_markers_between_nypd_orgs = 258;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCopyMarkersBetweenNypdOrgs = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 258, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCopyMarkersBetweenNypdOrgs = function(value) {
  return jspb.Message.setProto3BooleanField(this, 258, value);
};


/**
 * optional bool show_overlapping_dock_wifi_channels_fleet_page = 259;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowOverlappingDockWifiChannelsFleetPage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 259, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowOverlappingDockWifiChannelsFleetPage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 259, value);
};


/**
 * optional bool show_internal_mapbox_styles_3 = 261;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowInternalMapboxStyles3 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 261, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowInternalMapboxStyles3 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 261, value);
};


/**
 * optional bool fixed_location_rid = 262;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getFixedLocationRid = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 262, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setFixedLocationRid = function(value) {
  return jspb.Message.setProto3BooleanField(this, 262, value);
};


/**
 * optional bool alert_on_fly_to_point_altitude_change = 263;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAlertOnFlyToPointAltitudeChange = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 263, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAlertOnFlyToPointAltitudeChange = function(value) {
  return jspb.Message.setProto3BooleanField(this, 263, value);
};


/**
 * optional bool teleop_pilot_keep_alive = 264;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTeleopPilotKeepAlive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 264, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTeleopPilotKeepAlive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 264, value);
};


/**
 * optional bool ascend_solar_map_capture_demo = 270;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAscendSolarMapCaptureDemo = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 270, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAscendSolarMapCaptureDemo = function(value) {
  return jspb.Message.setProto3BooleanField(this, 270, value);
};


/**
 * optional bool use_world_takeoff_frame_fly_to_point = 271;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getUseWorldTakeoffFrameFlyToPoint = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 271, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setUseWorldTakeoffFrameFlyToPoint = function(value) {
  return jspb.Message.setProto3BooleanField(this, 271, value);
};


/**
 * optional bool enable_rtk_support = 272;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableRtkSupport = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 272, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableRtkSupport = function(value) {
  return jspb.Message.setProto3BooleanField(this, 272, value);
};


/**
 * optional bool city_customer_mapbox_map_styles = 274;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCityCustomerMapboxMapStyles = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 274, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCityCustomerMapboxMapStyles = function(value) {
  return jspb.Message.setProto3BooleanField(this, 274, value);
};


/**
 * optional bool link_loss_alert_level_caution = 276;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getLinkLossAlertLevelCaution = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 276, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setLinkLossAlertLevelCaution = function(value) {
  return jspb.Message.setProto3BooleanField(this, 276, value);
};


/**
 * optional bool enable_download_all_scan_files = 277;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableDownloadAllScanFiles = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 277, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableDownloadAllScanFiles = function(value) {
  return jspb.Message.setProto3BooleanField(this, 277, value);
};


/**
 * optional bool show_adsb_status_in_rfd = 279;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowAdsbStatusInRfd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 279, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowAdsbStatusInRfd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 279, value);
};


/**
 * optional bool show_vio_reset_cloud_override = 282;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowVioResetCloudOverride = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 282, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowVioResetCloudOverride = function(value) {
  return jspb.Message.setProto3BooleanField(this, 282, value);
};


/**
 * optional bool enable_streaming_rum_events = 283;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableStreamingRumEvents = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 283, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableStreamingRumEvents = function(value) {
  return jspb.Message.setProto3BooleanField(this, 283, value);
};


/**
 * optional bool enable_streaming_dd_logs = 302;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableStreamingDdLogs = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 302, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableStreamingDdLogs = function(value) {
  return jspb.Message.setProto3BooleanField(this, 302, value);
};


/**
 * optional bool disable_streaming_mixpanel_events = 421;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDisableStreamingMixpanelEvents = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 421, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDisableStreamingMixpanelEvents = function(value) {
  return jspb.Message.setProto3BooleanField(this, 421, value);
};


/**
 * optional bool display_media_sync_speed_test = 287;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDisplayMediaSyncSpeedTest = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 287, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDisplayMediaSyncSpeedTest = function(value) {
  return jspb.Message.setProto3BooleanField(this, 287, value);
};


/**
 * optional bool enable_setup_flights = 288;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableSetupFlights = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 288, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableSetupFlights = function(value) {
  return jspb.Message.setProto3BooleanField(this, 288, value);
};


/**
 * optional bool european_union = 289;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEuropeanUnion = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 289, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEuropeanUnion = function(value) {
  return jspb.Message.setProto3BooleanField(this, 289, value);
};


/**
 * optional bool enable_ev_shortcuts_rfd = 290;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableEvShortcutsRfd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 290, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableEvShortcutsRfd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 290, value);
};


/**
 * optional bool enable_settings_devices_access_point_ui = 291;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableSettingsDevicesAccessPointUi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 291, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableSettingsDevicesAccessPointUi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 291, value);
};


/**
 * optional bool enable_create_marker_interaction_rfd = 292;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableCreateMarkerInteractionRfd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 292, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableCreateMarkerInteractionRfd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 292, value);
};


/**
 * optional bool dronesense_integration_setup = 293;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDronesenseIntegrationSetup = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 293, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDronesenseIntegrationSetup = function(value) {
  return jspb.Message.setProto3BooleanField(this, 293, value);
};


/**
 * optional bool send_parquet_ingestor_jobs_to_temporal = 294;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSendParquetIngestorJobsToTemporal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 294, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSendParquetIngestorJobsToTemporal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 294, value);
};


/**
 * optional bool enable_c18_microhard_offline_configuration = 295;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableC18MicrohardOfflineConfiguration = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 295, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableC18MicrohardOfflineConfiguration = function(value) {
  return jspb.Message.setProto3BooleanField(this, 295, value);
};


/**
 * optional bool custom_map_layers_external = 296;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCustomMapLayersExternal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 296, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCustomMapLayersExternal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 296, value);
};


/**
 * optional bool custom_map_layers_internal = 297;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCustomMapLayersInternal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 297, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCustomMapLayersInternal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 297, value);
};


/**
 * optional bool dfr_command_phase_1_markers_ui = 298;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDfrCommandPhase1MarkersUi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 298, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDfrCommandPhase1MarkersUi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 298, value);
};


/**
 * optional bool enable_g47_dock_inspection_rfd = 299;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableG47DockInspectionRfd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 299, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableG47DockInspectionRfd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 299, value);
};


/**
 * optional bool disable_automatic_video_recording = 301;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDisableAutomaticVideoRecording = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 301, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDisableAutomaticVideoRecording = function(value) {
  return jspb.Message.setProto3BooleanField(this, 301, value);
};


/**
 * optional bool filter_markers_in_rfd_sidebar = 303;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getFilterMarkersInRfdSidebar = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 303, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setFilterMarkersInRfdSidebar = function(value) {
  return jspb.Message.setProto3BooleanField(this, 303, value);
};


/**
 * optional bool dfr_command = 305;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDfrCommand = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 305, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDfrCommand = function(value) {
  return jspb.Message.setProto3BooleanField(this, 305, value);
};


/**
 * optional bool mission_details_above_skills_switcher = 306;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMissionDetailsAboveSkillsSwitcher = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 306, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMissionDetailsAboveSkillsSwitcher = function(value) {
  return jspb.Message.setProto3BooleanField(this, 306, value);
};


/**
 * optional bool multi_battery_missions = 307;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMultiBatteryMissions = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 307, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMultiBatteryMissions = function(value) {
  return jspb.Message.setProto3BooleanField(this, 307, value);
};


/**
 * optional bool swap_to_x10_dock_cam_on_landing = 308;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSwapToX10DockCamOnLanding = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 308, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSwapToX10DockCamOnLanding = function(value) {
  return jspb.Message.setProto3BooleanField(this, 308, value);
};


/**
 * optional bool enable_rfd_hud_compass_v2 = 309;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableRfdHudCompassV2 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 309, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableRfdHudCompassV2 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 309, value);
};


/**
 * optional bool enable_rfd_dedrone = 310;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableRfdDedrone = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 310, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableRfdDedrone = function(value) {
  return jspb.Message.setProto3BooleanField(this, 310, value);
};


/**
 * optional bool enable_rfd_adsb_recording = 311;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableRfdAdsbRecording = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 311, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableRfdAdsbRecording = function(value) {
  return jspb.Message.setProto3BooleanField(this, 311, value);
};


/**
 * optional bool mission_editor_show_internal_navigation_mode_options = 313;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMissionEditorShowInternalNavigationModeOptions = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 313, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMissionEditorShowInternalNavigationModeOptions = function(value) {
  return jspb.Message.setProto3BooleanField(this, 313, value);
};


/**
 * optional bool enable_dfr_command_phase_two_ui = 314;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableDfrCommandPhaseTwoUi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 314, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableDfrCommandPhaseTwoUi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 314, value);
};


/**
 * optional bool enable_dfr_command_phase_two_point_five_ui = 315;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableDfrCommandPhaseTwoPointFiveUi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 315, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableDfrCommandPhaseTwoPointFiveUi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 315, value);
};


/**
 * optional bool enable_dfr_command_phase_three_ui = 316;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableDfrCommandPhaseThreeUi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 316, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableDfrCommandPhaseThreeUi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 316, value);
};


/**
 * optional bool enable_dfr_org_based_livekit_room = 317;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableDfrOrgBasedLivekitRoom = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 317, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableDfrOrgBasedLivekitRoom = function(value) {
  return jspb.Message.setProto3BooleanField(this, 317, value);
};


/**
 * optional bool x10_defaults_for_gps_init_waypoint = 318;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getX10DefaultsForGpsInitWaypoint = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 318, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setX10DefaultsForGpsInitWaypoint = function(value) {
  return jspb.Message.setProto3BooleanField(this, 318, value);
};


/**
 * optional bool ready_link_security_pin = 319;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getReadyLinkSecurityPin = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 319, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setReadyLinkSecurityPin = function(value) {
  return jspb.Message.setProto3BooleanField(this, 319, value);
};


/**
 * optional bool enable_dock_device_settings_page = 320;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableDockDeviceSettingsPage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 320, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableDockDeviceSettingsPage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 320, value);
};


/**
 * optional bool enable_media_sync_tab_on_device_settings_page = 321;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableMediaSyncTabOnDeviceSettingsPage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 321, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableMediaSyncTabOnDeviceSettingsPage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 321, value);
};


/**
 * optional bool enable_proper_ar_sync = 324;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableProperArSync = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 324, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableProperArSync = function(value) {
  return jspb.Message.setProto3BooleanField(this, 324, value);
};


/**
 * optional bool external_api_incident_markers_ui = 325;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getExternalApiIncidentMarkersUi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 325, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setExternalApiIncidentMarkersUi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 325, value);
};


/**
 * optional bool markers_area_filtering_ui = 326;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMarkersAreaFilteringUi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 326, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMarkersAreaFilteringUi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 326, value);
};


/**
 * optional bool markers_sidebar_sorting_ui = 327;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMarkersSidebarSortingUi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 327, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMarkersSidebarSortingUi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 327, value);
};


/**
 * optional bool enable_rfd_view_lookat_point = 329;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableRfdViewLookatPoint = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 329, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableRfdViewLookatPoint = function(value) {
  return jspb.Message.setProto3BooleanField(this, 329, value);
};


/**
 * optional bool enable_rfd_set_lookat_point = 330;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableRfdSetLookatPoint = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 330, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableRfdSetLookatPoint = function(value) {
  return jspb.Message.setProto3BooleanField(this, 330, value);
};


/**
 * optional bool enable_vehicle_device_settings_page = 331;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableVehicleDeviceSettingsPage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 331, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableVehicleDeviceSettingsPage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 331, value);
};


/**
 * optional bool fleet_flight_system_health = 332;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getFleetFlightSystemHealth = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 332, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setFleetFlightSystemHealth = function(value) {
  return jspb.Message.setProto3BooleanField(this, 332, value);
};


/**
 * optional bool simulate_remote_on_prem_org = 333;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSimulateRemoteOnPremOrg = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 333, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSimulateRemoteOnPremOrg = function(value) {
  return jspb.Message.setProto3BooleanField(this, 333, value);
};


/**
 * optional bool enable_rfd_agl_amsl = 335;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableRfdAglAmsl = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 335, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableRfdAglAmsl = function(value) {
  return jspb.Message.setProto3BooleanField(this, 335, value);
};


/**
 * optional bool ready_link_selectable_streams = 336;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getReadyLinkSelectableStreams = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 336, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setReadyLinkSelectableStreams = function(value) {
  return jspb.Message.setProto3BooleanField(this, 336, value);
};


/**
 * optional bool multi_org_users_rpic = 337;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMultiOrgUsersRpic = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 337, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMultiOrgUsersRpic = function(value) {
  return jspb.Message.setProto3BooleanField(this, 337, value);
};


/**
 * optional bool markers_api = 339;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMarkersApi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 339, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMarkersApi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 339, value);
};


/**
 * optional bool enable_props_hours_health = 340;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnablePropsHoursHealth = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 340, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnablePropsHoursHealth = function(value) {
  return jspb.Message.setProto3BooleanField(this, 340, value);
};


/**
 * optional bool allow_direct_device_adoption = 342;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAllowDirectDeviceAdoption = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 342, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAllowDirectDeviceAdoption = function(value) {
  return jspb.Message.setProto3BooleanField(this, 342, value);
};


/**
 * optional bool enable_dockless_sites = 343;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableDocklessSites = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 343, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableDocklessSites = function(value) {
  return jspb.Message.setProto3BooleanField(this, 343, value);
};


/**
 * optional bool enable_ramp_height_mode_fly_to_point_rfd = 344;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableRampHeightModeFlyToPointRfd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 344, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableRampHeightModeFlyToPointRfd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 344, value);
};


/**
 * optional bool deprecate_org_invitations = 345;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDeprecateOrgInvitations = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 345, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDeprecateOrgInvitations = function(value) {
  return jspb.Message.setProto3BooleanField(this, 345, value);
};


/**
 * optional bool enable_ready_link_1_point_3_ui = 346;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableReadyLink1Point3Ui = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 346, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableReadyLink1Point3Ui = function(value) {
  return jspb.Message.setProto3BooleanField(this, 346, value);
};


/**
 * optional bool enable_teleop_in_iframe = 347;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableTeleopInIframe = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 347, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableTeleopInIframe = function(value) {
  return jspb.Message.setProto3BooleanField(this, 347, value);
};


/**
 * optional bool enable_dfr_dockview_layout = 348;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableDfrDockviewLayout = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 348, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableDfrDockviewLayout = function(value) {
  return jspb.Message.setProto3BooleanField(this, 348, value);
};


/**
 * optional bool enable_customer_managed_session_lengths = 349;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableCustomerManagedSessionLengths = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 349, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableCustomerManagedSessionLengths = function(value) {
  return jspb.Message.setProto3BooleanField(this, 349, value);
};


/**
 * optional bool enable_standoff_distance = 350;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableStandoffDistance = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 350, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableStandoffDistance = function(value) {
  return jspb.Message.setProto3BooleanField(this, 350, value);
};


/**
 * optional bool support_user_expiry = 351;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSupportUserExpiry = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 351, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSupportUserExpiry = function(value) {
  return jspb.Message.setProto3BooleanField(this, 351, value);
};


/**
 * optional bool enable_dispatch_respond_here = 352;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableDispatchRespondHere = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 352, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableDispatchRespondHere = function(value) {
  return jspb.Message.setProto3BooleanField(this, 352, value);
};


/**
 * optional bool ready_link_multi_vehicle_select = 354;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getReadyLinkMultiVehicleSelect = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 354, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setReadyLinkMultiVehicleSelect = function(value) {
  return jspb.Message.setProto3BooleanField(this, 354, value);
};


/**
 * optional bool deployment_engineer_missions_internal = 355;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDeploymentEngineerMissionsInternal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 355, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDeploymentEngineerMissionsInternal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 355, value);
};


/**
 * optional bool add_api_tokens_to_resource_groups = 356;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAddApiTokensToResourceGroups = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 356, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAddApiTokensToResourceGroups = function(value) {
  return jspb.Message.setProto3BooleanField(this, 356, value);
};


/**
 * optional bool set_take_photo_wait_for_focus_to_converge = 357;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSetTakePhotoWaitForFocusToConverge = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 357, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSetTakePhotoWaitForFocusToConverge = function(value) {
  return jspb.Message.setProto3BooleanField(this, 357, value);
};


/**
 * optional bool cloud_rel_3_ui_updates = 358;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCloudRel3UiUpdates = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 358, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCloudRel3UiUpdates = function(value) {
  return jspb.Message.setProto3BooleanField(this, 358, value);
};


/**
 * optional bool enable_manual_incident_creation = 359;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableManualIncidentCreation = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 359, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableManualIncidentCreation = function(value) {
  return jspb.Message.setProto3BooleanField(this, 359, value);
};


/**
 * optional bool enable_validation_of_on_demand_mission = 360;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableValidationOfOnDemandMission = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 360, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableValidationOfOnDemandMission = function(value) {
  return jspb.Message.setProto3BooleanField(this, 360, value);
};


/**
 * optional bool enable_axon_watch_me_demo = 361;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableAxonWatchMeDemo = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 361, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableAxonWatchMeDemo = function(value) {
  return jspb.Message.setProto3BooleanField(this, 361, value);
};


/**
 * optional bool battery_device_page = 362;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getBatteryDevicePage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 362, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setBatteryDevicePage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 362, value);
};


/**
 * optional bool enable_incidents_state_ui = 363;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableIncidentsStateUi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 363, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableIncidentsStateUi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 363, value);
};


/**
 * optional bool enable_planning_around_geofences_fly_to_point_rfd = 364;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnablePlanningAroundGeofencesFlyToPointRfd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 364, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnablePlanningAroundGeofencesFlyToPointRfd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 364, value);
};


/**
 * optional bool battery_firmware_increment = 365;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getBatteryFirmwareIncrement = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 365, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setBatteryFirmwareIncrement = function(value) {
  return jspb.Message.setProto3BooleanField(this, 365, value);
};


/**
 * optional bool cloud_rel_4_ui_updates = 367;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCloudRel4UiUpdates = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 367, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCloudRel4UiUpdates = function(value) {
  return jspb.Message.setProto3BooleanField(this, 367, value);
};


/**
 * optional bool hive_channel_conflict_prevention = 368;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getHiveChannelConflictPrevention = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 368, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setHiveChannelConflictPrevention = function(value) {
  return jspb.Message.setProto3BooleanField(this, 368, value);
};


/**
 * optional bool sort_drone_selection_modal_dispatch = 369;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSortDroneSelectionModalDispatch = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 369, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSortDroneSelectionModalDispatch = function(value) {
  return jspb.Message.setProto3BooleanField(this, 369, value);
};


/**
 * optional bool unified_mission_editor = 370;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getUnifiedMissionEditor = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 370, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setUnifiedMissionEditor = function(value) {
  return jspb.Message.setProto3BooleanField(this, 370, value);
};


/**
 * optional bool missions_cloud_to_controller = 371;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMissionsCloudToController = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 371, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMissionsCloudToController = function(value) {
  return jspb.Message.setProto3BooleanField(this, 371, value);
};


/**
 * optional bool enable_waypoint_metrics_workflow = 372;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableWaypointMetricsWorkflow = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 372, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableWaypointMetricsWorkflow = function(value) {
  return jspb.Message.setProto3BooleanField(this, 372, value);
};


/**
 * optional bool enable_propeller_type_specification = 373;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnablePropellerTypeSpecification = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 373, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnablePropellerTypeSpecification = function(value) {
  return jspb.Message.setProto3BooleanField(this, 373, value);
};


/**
 * optional bool improved_landing_buttons = 374;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getImprovedLandingButtons = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 374, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setImprovedLandingButtons = function(value) {
  return jspb.Message.setProto3BooleanField(this, 374, value);
};


/**
 * optional bool enable_axon_sha256 = 375;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableAxonSha256 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 375, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableAxonSha256 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 375, value);
};


/**
 * optional bool enable_cancel_incident_response_modal = 376;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableCancelIncidentResponseModal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 376, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableCancelIncidentResponseModal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 376, value);
};


/**
 * optional bool controller_device_page = 377;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getControllerDevicePage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 377, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setControllerDevicePage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 377, value);
};


/**
 * optional bool display_cellular_carrier_info = 378;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDisplayCellularCarrierInfo = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 378, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDisplayCellularCarrierInfo = function(value) {
  return jspb.Message.setProto3BooleanField(this, 378, value);
};


/**
 * optional bool enable_unsupported_browser_warning = 379;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableUnsupportedBrowserWarning = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 379, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableUnsupportedBrowserWarning = function(value) {
  return jspb.Message.setProto3BooleanField(this, 379, value);
};


/**
 * optional bool enable_extra_access_modes = 380;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableExtraAccessModes = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 380, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableExtraAccessModes = function(value) {
  return jspb.Message.setProto3BooleanField(this, 380, value);
};


/**
 * optional bool enable_custom_map_layers_backend = 381;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableCustomMapLayersBackend = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 381, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableCustomMapLayersBackend = function(value) {
  return jspb.Message.setProto3BooleanField(this, 381, value);
};


/**
 * optional bool enable_priority_dfr_cloud_ia = 382;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnablePriorityDfrCloudIa = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 382, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnablePriorityDfrCloudIa = function(value) {
  return jspb.Message.setProto3BooleanField(this, 382, value);
};


/**
 * optional bool reverse_geocode_markers_on_read = 383;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getReverseGeocodeMarkersOnRead = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 383, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setReverseGeocodeMarkersOnRead = function(value) {
  return jspb.Message.setProto3BooleanField(this, 383, value);
};


/**
 * optional bool edit_org_flight_policy_nondocked = 385;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEditOrgFlightPolicyNondocked = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 385, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEditOrgFlightPolicyNondocked = function(value) {
  return jspb.Message.setProto3BooleanField(this, 385, value);
};


/**
 * optional bool sites_improvements_5_25 = 387;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSitesImprovements525 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 387, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSitesImprovements525 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 387, value);
};


/**
 * optional bool cloud_rel_5_ui_updates = 388;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCloudRel5UiUpdates = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 388, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCloudRel5UiUpdates = function(value) {
  return jspb.Message.setProto3BooleanField(this, 388, value);
};


/**
 * optional bool show_file_release_ui = 389;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowFileReleaseUi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 389, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowFileReleaseUi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 389, value);
};


/**
 * optional bool use_x10rev1_and_unknown_accelerated_prop_wear_alert = 390;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getUseX10rev1AndUnknownAcceleratedPropWearAlert = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 390, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setUseX10rev1AndUnknownAcceleratedPropWearAlert = function(value) {
  return jspb.Message.setProto3BooleanField(this, 390, value);
};


/**
 * optional bool use_x10rev2_accelerated_prop_wear_alert = 391;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getUseX10rev2AcceleratedPropWearAlert = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 391, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setUseX10rev2AcceleratedPropWearAlert = function(value) {
  return jspb.Message.setProto3BooleanField(this, 391, value);
};


/**
 * optional bool rtk_early_access_program = 392;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRtkEarlyAccessProgram = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 392, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRtkEarlyAccessProgram = function(value) {
  return jspb.Message.setProto3BooleanField(this, 392, value);
};


/**
 * optional bool new_cloud_navigation = 393;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getNewCloudNavigation = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 393, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setNewCloudNavigation = function(value) {
  return jspb.Message.setProto3BooleanField(this, 393, value);
};


/**
 * optional bool api_observability = 394;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getApiObservability = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 394, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setApiObservability = function(value) {
  return jspb.Message.setProto3BooleanField(this, 394, value);
};


/**
 * optional bool new_integrations_ui = 395;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getNewIntegrationsUi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 395, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setNewIntegrationsUi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 395, value);
};


/**
 * optional bool show_sw_incompatibility_health_issue = 396;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowSwIncompatibilityHealthIssue = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 396, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowSwIncompatibilityHealthIssue = function(value) {
  return jspb.Message.setProto3BooleanField(this, 396, value);
};


/**
 * optional bool updated_create_organization_modal = 397;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getUpdatedCreateOrganizationModal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 397, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setUpdatedCreateOrganizationModal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 397, value);
};


/**
 * optional bool cloud_sim_automatic_site_setup = 398;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCloudSimAutomaticSiteSetup = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 398, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCloudSimAutomaticSiteSetup = function(value) {
  return jspb.Message.setProto3BooleanField(this, 398, value);
};


/**
 * optional bool ready_link_viewer_count_poll = 399;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getReadyLinkViewerCountPoll = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 399, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setReadyLinkViewerCountPoll = function(value) {
  return jspb.Message.setProto3BooleanField(this, 399, value);
};


/**
 * optional bool sensor_package_details_enabled_ui = 401;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSensorPackageDetailsEnabledUi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 401, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSensorPackageDetailsEnabledUi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 401, value);
};


/**
 * optional bool enable_post_flight_reports = 402;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnablePostFlightReports = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 402, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnablePostFlightReports = function(value) {
  return jspb.Message.setProto3BooleanField(this, 402, value);
};


/**
 * optional bool ar_goal_as_standoff_indicator = 404;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getArGoalAsStandoffIndicator = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 404, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setArGoalAsStandoffIndicator = function(value) {
  return jspb.Message.setProto3BooleanField(this, 404, value);
};


/**
 * optional bool show_attachment_details_in_customer_portal = 405;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowAttachmentDetailsInCustomerPortal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 405, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowAttachmentDetailsInCustomerPortal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 405, value);
};


/**
 * optional bool enable_dfr_outcomes_survey = 406;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableDfrOutcomesSurvey = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 406, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableDfrOutcomesSurvey = function(value) {
  return jspb.Message.setProto3BooleanField(this, 406, value);
};


/**
 * optional bool rfd_streamline_notifications = 407;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRfdStreamlineNotifications = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 407, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRfdStreamlineNotifications = function(value) {
  return jspb.Message.setProto3BooleanField(this, 407, value);
};


/**
 * optional bool filter_marker_button_in_sidebar = 408;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getFilterMarkerButtonInSidebar = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 408, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setFilterMarkerButtonInSidebar = function(value) {
  return jspb.Message.setProto3BooleanField(this, 408, value);
};


/**
 * optional bool enable_battery_fretting_alerts = 409;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableBatteryFrettingAlerts = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 409, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableBatteryFrettingAlerts = function(value) {
  return jspb.Message.setProto3BooleanField(this, 409, value);
};


/**
 * optional bool enable_distribution_list = 410;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableDistributionList = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 410, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableDistributionList = function(value) {
  return jspb.Message.setProto3BooleanField(this, 410, value);
};


/**
 * optional bool include_case_ids_in_axon_evidence_title = 411;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getIncludeCaseIdsInAxonEvidenceTitle = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 411, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setIncludeCaseIdsInAxonEvidenceTitle = function(value) {
  return jspb.Message.setProto3BooleanField(this, 411, value);
};


/**
 * optional bool show_internal_flight_deck_commands = 412;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowInternalFlightDeckCommands = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 412, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowInternalFlightDeckCommands = function(value) {
  return jspb.Message.setProto3BooleanField(this, 412, value);
};


/**
 * optional bool show_drawer_sidebar = 413;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowDrawerSidebar = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 413, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowDrawerSidebar = function(value) {
  return jspb.Message.setProto3BooleanField(this, 413, value);
};


/**
 * optional bool turbo_redux_bridge = 414;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTurboReduxBridge = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 414, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTurboReduxBridge = function(value) {
  return jspb.Message.setProto3BooleanField(this, 414, value);
};


/**
 * optional bool use_new_flashpack_channels = 415;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getUseNewFlashpackChannels = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 415, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setUseNewFlashpackChannels = function(value) {
  return jspb.Message.setProto3BooleanField(this, 415, value);
};


/**
 * optional bool disable_email_logins = 416;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDisableEmailLogins = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 416, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDisableEmailLogins = function(value) {
  return jspb.Message.setProto3BooleanField(this, 416, value);
};


/**
 * optional bool enable_fusus_cad_poller = 417;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableFususCadPoller = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 417, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableFususCadPoller = function(value) {
  return jspb.Message.setProto3BooleanField(this, 417, value);
};


/**
 * optional bool cloud_rel_6_ui_updates = 418;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCloudRel6UiUpdates = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 418, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCloudRel6UiUpdates = function(value) {
  return jspb.Message.setProto3BooleanField(this, 418, value);
};


/**
 * optional bool cloud_rel_7_ui_updates = 419;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCloudRel7UiUpdates = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 419, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCloudRel7UiUpdates = function(value) {
  return jspb.Message.setProto3BooleanField(this, 419, value);
};


/**
 * optional bool multiple_media_sync_policies = 420;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMultipleMediaSyncPolicies = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 420, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMultipleMediaSyncPolicies = function(value) {
  return jspb.Message.setProto3BooleanField(this, 420, value);
};


/**
 * optional bool show_a22_details_in_ui = 422;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowA22DetailsInUi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 422, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowA22DetailsInUi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 422, value);
};


/**
 * optional bool other_device_page = 423;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getOtherDevicePage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 423, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setOtherDevicePage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 423, value);
};


/**
 * optional bool subject_tracking = 424;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSubjectTracking = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 424, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSubjectTracking = function(value) {
  return jspb.Message.setProto3BooleanField(this, 424, value);
};


/**
 * optional bool asset_inspection_mission_planning_v0 = 425;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAssetInspectionMissionPlanningV0 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 425, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAssetInspectionMissionPlanningV0 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 425, value);
};


/**
 * optional bool enable_pre_flight_checklists = 426;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnablePreFlightChecklists = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 426, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnablePreFlightChecklists = function(value) {
  return jspb.Message.setProto3BooleanField(this, 426, value);
};


/**
 * optional bool branding_dfr_command = 427;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getBrandingDfrCommand = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 427, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setBrandingDfrCommand = function(value) {
  return jspb.Message.setProto3BooleanField(this, 427, value);
};


/**
 * optional bool show_cellular_configs = 428;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowCellularConfigs = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 428, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowCellularConfigs = function(value) {
  return jspb.Message.setProto3BooleanField(this, 428, value);
};


/**
 * optional bool enable_surface_scan_skill_teleop = 429;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableSurfaceScanSkillTeleop = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 429, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableSurfaceScanSkillTeleop = function(value) {
  return jspb.Message.setProto3BooleanField(this, 429, value);
};


/**
 * optional bool autonomy_widget_rfd = 430;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAutonomyWidgetRfd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 430, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAutonomyWidgetRfd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 430, value);
};


/**
 * optional bool show_propeller_hours_tracking_override_setting = 431;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowPropellerHoursTrackingOverrideSetting = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 431, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowPropellerHoursTrackingOverrideSetting = function(value) {
  return jspb.Message.setProto3BooleanField(this, 431, value);
};


/**
 * optional bool dock_compute_replacement = 432;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDockComputeReplacement = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 432, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDockComputeReplacement = function(value) {
  return jspb.Message.setProto3BooleanField(this, 432, value);
};


/**
 * optional bool enable_create_stub_flight_workflow = 433;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableCreateStubFlightWorkflow = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 433, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableCreateStubFlightWorkflow = function(value) {
  return jspb.Message.setProto3BooleanField(this, 433, value);
};


/**
 * optional bool axon_global_region = 434;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAxonGlobalRegion = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 434, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAxonGlobalRegion = function(value) {
  return jspb.Message.setProto3BooleanField(this, 434, value);
};


/**
 * optional bool allow_scan_plane_offset_for_map_capture = 435;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAllowScanPlaneOffsetForMapCapture = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 435, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAllowScanPlaneOffsetForMapCapture = function(value) {
  return jspb.Message.setProto3BooleanField(this, 435, value);
};


/**
 * optional bool rtk_ppk_rfd_telemetry = 436;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRtkPpkRfdTelemetry = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 436, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRtkPpkRfdTelemetry = function(value) {
  return jspb.Message.setProto3BooleanField(this, 436, value);
};


/**
 * optional bool subject_tracking_for_engineering = 437;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSubjectTrackingForEngineering = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 437, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSubjectTrackingForEngineering = function(value) {
  return jspb.Message.setProto3BooleanField(this, 437, value);
};


/**
 * optional bool prepared_911_integration = 438;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getPrepared911Integration = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 438, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setPrepared911Integration = function(value) {
  return jspb.Message.setProto3BooleanField(this, 438, value);
};


/**
 * optional bool enable_multidrone_ascend_fy26 = 440;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableMultidroneAscendFy26 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 440, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableMultidroneAscendFy26 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 440, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud_api.FeatureFlagRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud_api.FeatureFlagRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud_api.FeatureFlagRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.FeatureFlagRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
organizationId: jspb.Message.getFieldWithDefault(msg, 1, ""),
organizationPermission: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud_api.FeatureFlagRequest}
 */
proto.cloud_api.FeatureFlagRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud_api.FeatureFlagRequest;
  return proto.cloud_api.FeatureFlagRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud_api.FeatureFlagRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud_api.FeatureFlagRequest}
 */
proto.cloud_api.FeatureFlagRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationId(value);
      break;
    case 2:
      var value = /** @type {!proto.cloud_api.OrgPermission.PermEnum} */ (reader.readEnum());
      msg.setOrganizationPermission(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud_api.FeatureFlagRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud_api.FeatureFlagRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud_api.FeatureFlagRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.FeatureFlagRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrganizationPermission();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string organization_id = 1;
 * @return {string}
 */
proto.cloud_api.FeatureFlagRequest.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud_api.FeatureFlagRequest} returns this
 */
proto.cloud_api.FeatureFlagRequest.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional OrgPermission.PermEnum organization_permission = 2;
 * @return {!proto.cloud_api.OrgPermission.PermEnum}
 */
proto.cloud_api.FeatureFlagRequest.prototype.getOrganizationPermission = function() {
  return /** @type {!proto.cloud_api.OrgPermission.PermEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.cloud_api.OrgPermission.PermEnum} value
 * @return {!proto.cloud_api.FeatureFlagRequest} returns this
 */
proto.cloud_api.FeatureFlagRequest.prototype.setOrganizationPermission = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


goog.object.extend(exports, proto.cloud_api);
